"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5673],{

/***/ 65673:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "u": function() { return /* binding */ IPDView; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/utils.ts
var utils = __webpack_require__(90759);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Modal.js + 5 modules
var Modal = __webpack_require__(32321);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Button.js
var Button = __webpack_require__(35005);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Row.js
var Row = __webpack_require__(34051);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Col.js
var Col = __webpack_require__(31555);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Table.js
var Table = __webpack_require__(75147);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Form.js + 9 modules
var Form = __webpack_require__(3162);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
// EXTERNAL MODULE: ./node_modules/react-bs-datatable/lib/esm/index.js + 16 modules
var esm = __webpack_require__(51729);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Accordion.js + 7 modules
var Accordion = __webpack_require__(5607);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Tabs.js
var Tabs = __webpack_require__(85509);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Tab.js + 1 modules
var Tab = __webpack_require__(73192);
// EXTERNAL MODULE: ./node_modules/react-vertical-timeline-component/dist-es6/index.js
var dist_es6 = __webpack_require__(14313);
// EXTERNAL MODULE: ./node_modules/react-vertical-timeline-component/style.min.css
var style_min = __webpack_require__(74107);
// EXTERNAL MODULE: ./components/diagnostics/DiagnosticsVisitView.tsx + 6 modules
var DiagnosticsVisitView = __webpack_require__(71992);
;// CONCATENATED MODULE: ./components/ipd/subCategories/records/RecordView.tsx







var RecordView = function(props) {
    var ref = (0,react.useState)(null), record = ref[0], setRecord = ref[1];
    (0,react.useEffect)(function() {
        if (props.data) {
            axios_default().get("/api/backend/customer/records/fetch/id/" + props.data.medicalRecordId).then(function(resp) {
                console.log(JSON.stringify(resp.data));
                setRecord(resp.data);
            }).catch(function(err) {
                console.error(err);
                if (err.response && err.response.status && err.response.status === 403) {
                    (0,utils/* handleLogout */.hY)();
                }
            });
        }
    }, [
        props.data
    ]);
    var handleDeleteRecordModal = function() {
        axios_default().get("/api/backend/ipd/case/audit/remove/" + props.data.id).then(function(resp) {
            console.log(JSON.stringify(resp.data));
            props.reloadMethod();
        }).catch(function(err) {
            console.error(err);
            if (err.response && err.response.status && err.response.status === 403) {
                (0,utils/* handleLogout */.hY)();
            }
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_es6.VerticalTimelineElement, {
        className: "vertical-timeline-element--work",
        contentStyle: {
            background: "#ebecff",
            color: "black"
        },
        contentArrowStyle: {
            borderRight: "7px solid  #ebecff"
        },
        date: props.data.createdAt + " - " + (props.data.createdByName && props.data.createdByName.split("@")[0]),
        iconStyle: {
            background: "#ebecff",
            fontSize: 25,
            textAlign: "center"
        },
        icon: "⚕️",
        children: [
            props.caseStatus != "CLOSED" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "float-right",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    href: "#/",
                    className: "text-decoration-none remove font-weight-bold",
                    onClick: handleDeleteRecordModal,
                    children: "X"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DiagnosticsVisitView/* DiagnosticsVisitView */.e, {
                    uhid: props.uhid,
                    visitId: props.data.id,
                    entityQr: props.cookieEntityQr,
                    source: "IPD",
                    diagnosticCategory: null,
                    shouldAddNew: false,
                    createVisit: null
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/ipd/subCategories/procedure/ProcedureView.tsx






var ProcedureView = function(props) {
    var handleDeleteProcedureModal = function() {
        axios_default().get("/api/backend/ipd/case/audit/remove/" + props.data.id).then(function(resp) {
            console.log(JSON.stringify(resp.data));
            props.reloadMethod();
        }).catch(function(err) {
            console.error(err);
            if (err.response && err.response.status && err.response.status === 403) {
                (0,utils/* handleLogout */.hY)();
            }
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_es6.VerticalTimelineElement, {
        className: "vertical-timeline-element--work",
        contentStyle: {
            background: "#ebecff",
            color: "black"
        },
        contentArrowStyle: {
            borderRight: "7px solid  #ebecff"
        },
        date: props.data.createdAt + " - " + (props.data.createdByName && props.data.createdByName.split("@")[0]),
        iconStyle: {
            background: "#ebecff",
            fontSize: 25,
            textAlign: "center"
        },
        icon: "\uD83E\uDEA1",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "d-flex justify-content-between",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "d-flex gap-2",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "fs-6 text-secondary align-self-center",
                                    children: "Doctor:"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "fs-6 font-weight-bold",
                                    children: [
                                        " ",
                                        props.data.drInCharge
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "d-flex gap-2",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "fs-6 text-secondary align-self-center",
                                    children: "Procedure:"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "fs-6 fw-bold d-inline-block",
                                    children: [
                                        " ",
                                        props.data.procedureName
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "d-flex gap-2",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "fs-6 text-secondary",
                                    children: "Procedure Details:"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "fs-6 d-inline-block",
                                    dangerouslySetInnerHTML: {
                                        __html: props.data.procedureDetails
                                    }
                                })
                            ]
                        })
                    ]
                }),
                props.caseStatus != "CLOSED" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: "#/",
                            className: "text-primary font-weight-bold",
                            onClick: function(e) {
                                return props.editMethod(props.data);
                            },
                            children: "✎"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: "#/",
                            className: "text-decoration-none remove font-weight-bold",
                            onClick: handleDeleteProcedureModal,
                            children: "\xa0\xa0\xa0\xa0X"
                        })
                    ]
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./node_modules/react-datetime-picker/dist/esm/index.js + 71 modules
var dist_esm = __webpack_require__(55951);
// EXTERNAL MODULE: ./node_modules/react-datetime-picker/dist/DateTimePicker.css
var DateTimePicker = __webpack_require__(13534);
// EXTERNAL MODULE: ./node_modules/react-calendar/dist/Calendar.css
var Calendar = __webpack_require__(19318);
// EXTERNAL MODULE: ./node_modules/react-clock/dist/Clock.css
var Clock = __webpack_require__(32693);
;// CONCATENATED MODULE: ./components/ipd/subCategories/bed/BedView.tsx











var BedView = function(props) {
    var ref = (0,react.useState)(null), bedName = ref[0], setBedName = ref[1];
    var ref1 = (0,react.useState)(false), isEdit = ref1[0], setIsEdit = ref1[1];
    var ref2 = (0,react.useState)(new Date()), oldDateTime = ref2[0], setOldDateTime = ref2[1];
    var ref3 = (0,react.useState)(new Date()), newEventDateTime = ref3[0], setNewEventDateime = ref3[1];
    var ref4 = (0,react.useState)(null), err = ref4[0], setErr = ref4[1];
    (0,react.useEffect)(function() {
        if (props.data) {
            axios_default().get("/api/backend/inventory/item/fetch/id/" + props.data.bedId).then(function(resp) {
                console.log(JSON.stringify(resp.data));
                setBedName(resp.data.name);
            }).catch(function(err) {
                console.error(err);
                if (err.response && err.response.status && err.response.status === 403) {
                    (0,utils/* handleLogout */.hY)();
                }
            });
            setOldDateTime(new Date(props.data.eventDate));
            setNewEventDateime(new Date(props.data.eventDate));
        }
    }, [
        props.data
    ]);
    var handleUpdate = function(e) {
        e.preventDefault();
        setIsEdit(false);
        axios_default().post("/api/backend/ipd/case/audit/update/event/date/" + props.data.id + "?newEventDate=" + encodeURIComponent(newEventDateTime.toISOString()), {}).then(function(resp) {
            console.log(JSON.stringify(resp.data));
            setOldDateTime(newEventDateTime);
        }).catch(function(err) {
            console.error(err);
            if (err.response && err.response.status && err.response.status === 403) {
                (0,utils/* handleLogout */.hY)();
            }
            setErr("* The date you are specifying is older than previous bed assignment event or case creation. Please validate the date.");
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_es6.VerticalTimelineElement, {
        className: "vertical-timeline-element--work",
        contentStyle: {
            background: "#ebecff",
            color: "black"
        },
        contentArrowStyle: {
            borderRight: "7px solid  #ebecff"
        },
        date: props.data.createdAt + " - " + props.data.createdByName.split("@")[0],
        iconStyle: {
            background: "#ebecff",
            fontSize: 25,
            textAlign: "center"
        },
        icon: "\uD83D\uDECC",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "d-flex justify-content-between",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        bedName && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "d-flex gap-2",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "fs-6 text-secondary align-self-center",
                                    children: "Assigned Bed:"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "fs-5",
                                    children: [
                                        " ",
                                        bedName
                                    ]
                                })
                            ]
                        }),
                        bedName && !isEdit && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "d-flex gap-2",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "fs-6 text-secondary align-self-center",
                                    children: "Assigned On:"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "fs-6",
                                    children: [
                                        " ",
                                        oldDateTime.toLocaleDateString("en-GB"),
                                        "\xa0",
                                        oldDateTime.toLocaleTimeString("en-GB")
                                    ]
                                }),
                                props.caseStatus != "CLOSED" && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: "#/",
                                    className: "text-warning font-weight-bold",
                                    onClick: function(e) {
                                        e.preventDefault();
                                        setErr(null);
                                        setIsEdit(true);
                                    },
                                    children: "✎"
                                })
                            ]
                        }),
                        bedName && isEdit && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "d-flex gap-1",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "fs-6 text-secondary align-self-center",
                                    children: "Assigned On:"
                                }),
                                newEventDateTime && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_esm/* default */.Z, {
                                    onChange: setNewEventDateime,
                                    clearIcon: null,
                                    value: newEventDateTime
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                            className: "btn btn-light btn-sm",
                                            onClick: function(e) {
                                                return handleUpdate(e);
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "text-primary font-weight-bold",
                                                children: "✓"
                                            })
                                        }),
                                        "\xa0",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                            className: "btn btn-light btn-sm",
                                            onClick: function(e) {
                                                return setIsEdit(false);
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "remove font-weight-bold",
                                                children: "X"
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        !bedName && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "fs-6 text-secondary align-self-center",
                            children: "Bed Unassigned"
                        }),
                        !bedName && !isEdit && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "d-flex gap-2",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "fs-6 text-secondary align-self-center",
                                    children: "Unassigned On:"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "fs-6",
                                    children: [
                                        " ",
                                        oldDateTime.toLocaleDateString("en-GB"),
                                        "\xa0",
                                        oldDateTime.toLocaleTimeString("en-GB")
                                    ]
                                }),
                                props.caseStatus != "CLOSED" && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: "#/",
                                    className: "text-warning font-weight-bold",
                                    onClick: function(e) {
                                        e.preventDefault();
                                        setIsEdit(true);
                                    },
                                    children: "✎"
                                })
                            ]
                        }),
                        !bedName && isEdit && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "d-flex gap-2",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "fs-6 text-secondary align-self-center",
                                    children: "Unassigned On:"
                                }),
                                newEventDateTime && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_esm/* default */.Z, {
                                    onChange: setNewEventDateime,
                                    clearIcon: null,
                                    value: newEventDateTime
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                            className: "btn btn-light btn-sm",
                                            onClick: function(e) {
                                                return handleUpdate(e);
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "text-success font-weight-bold",
                                                children: "✓"
                                            })
                                        }),
                                        "\xa0",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                            className: "btn btn-light btn-sm",
                                            onClick: function(e) {
                                                return setIsEdit(false);
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "text-danger font-weight-bold",
                                                children: "X"
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                err && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "my-3 text-danger fs-7",
                    children: err
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./components/ipd/IpdPrescriptionWritingView.tsx
var IpdPrescriptionWritingView = __webpack_require__(28235);
// EXTERNAL MODULE: ./components/customer/category/PatientVitalsView.tsx
var PatientVitalsView = __webpack_require__(61488);
;// CONCATENATED MODULE: ./components/ipd/subCategories/visit/VisitView.tsx








var VisitView = function(props) {
    var handleDeleteVisitModal = function() {
        axios_default().get("/api/backend/ipd/case/audit/remove/" + props.data.id).then(function(resp) {
            console.log(JSON.stringify(resp.data));
            props.reloadMethod();
        }).catch(function(err) {
            console.error(err);
            if (err.response && err.response.status && err.response.status === 403) {
                (0,utils/* handleLogout */.hY)();
            }
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_es6.VerticalTimelineElement, {
        className: "vertical-timeline-element--work",
        contentStyle: {
            background: "#ebecff",
            color: "black"
        },
        contentArrowStyle: {
            borderRight: "7px solid  #ebecff"
        },
        date: props.data.createdAt + " - " + (props.data.createdByName && props.data.createdByName.split("@")[0]),
        iconStyle: {
            background: "#ebecff",
            fontSize: 25,
            textAlign: "center"
        },
        icon: "\uD83D\uDC68‍⚕️",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "d-flex justify-content-between",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex-grow-1",
                    children: [
                        props.data.drInCharge && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "d-flex gap-2",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "fs-6 text-secondary align-self-center",
                                    children: "Visiting Doctor:"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "fs-6 font-weight-bold",
                                    children: [
                                        " ",
                                        props.data.drInCharge
                                    ]
                                })
                            ]
                        }),
                        props.data.vitals && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "d-flex gap-2",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PatientVitalsView/* PatientVitalsView */.d, {
                                vitals: JSON.parse(props.data.vitals),
                                isEditable: false,
                                updateVitals: null,
                                qrCode: null
                            })
                        }),
                        props.data.notes && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "d-flex gap-2",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "fs-6 text-secondary",
                                    children: "Notes:"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "fs-6",
                                    dangerouslySetInnerHTML: {
                                        __html: props.data.notes
                                    }
                                })
                            ]
                        }),
                        props.data.presId != 0 && props.data.presId && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IpdPrescriptionWritingView/* IpdPrescriptionWritingView */.X, {
                                entityQr: props.cookieEntityQr,
                                isEditable: false,
                                qrCode: props.data.clientQr,
                                id: props.data.presId
                            })
                        })
                    ]
                }),
                props.caseStatus != "CLOSED" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: "#/",
                            className: "text-primary font-weight-bold",
                            onClick: function(e) {
                                return props.editMethod(props.data);
                            },
                            children: "✎"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: "#/",
                            className: "text-decoration-none remove font-weight-bold",
                            onClick: handleDeleteVisitModal,
                            children: "\xa0\xa0\xa0\xa0X"
                        })
                    ]
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./components/ipd/subCategories/discharge/DischargeView.tsx





var DischargeView = function(props) {
    var ref = (0,react.useState)("DISCHARGE"), patientStatus = ref[0], setPatientStatus = ref[1];
    var ref1 = (0,react.useState)(null), approvers = ref1[0], setApprovers = ref1[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_es6.VerticalTimelineElement, {
        className: "vertical-timeline-element--work",
        contentStyle: {
            background: "#ebecff",
            color: "black"
        },
        contentArrowStyle: {
            borderRight: "7px solid  #ebecff"
        },
        date: props.data.createdAt + " - " + (props.data.createdByName && props.data.createdByName.split("@")[0]),
        iconStyle: {
            background: "#ebecff",
            fontSize: 25,
            textAlign: "center"
        },
        icon: "",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: "text-warning",
                children: "Patient Discharged"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "d-flex justify-content-between",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex-grow-1",
                    children: [
                        props.data.patientStatus && props.data.patientStatus != "DISCHARGE" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "d-flex gap-2",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "fs-6 text-secondary",
                                    children: "Discharge Status:"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "fs-6",
                                    children: props.data.patientStatus == "DEATH" ? "Death" : "LAMA"
                                })
                            ]
                        }),
                        props.data.extraDetails && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "d-flex gap-2",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "fs-6 text-secondary",
                                    children: "Clinical Approval by:"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "fs-6",
                                    children: JSON.parse(props.data.extraDetails).clinical_approver
                                })
                            ]
                        }),
                        props.data.extraDetails && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "d-flex gap-2",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "fs-6 text-secondary",
                                    children: "Accounts Approval by:"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "fs-6",
                                    children: JSON.parse(props.data.extraDetails).accounts_approver
                                })
                            ]
                        }),
                        props.data.notes && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "d-flex gap-2",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "fs-6 text-secondary",
                                    children: "Discharge Remarks:"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "fs-6",
                                    dangerouslySetInnerHTML: {
                                        __html: props.data.notes
                                    }
                                })
                            ]
                        }),
                        props.data.presId != 0 && props.data.presId && /*#__PURE__*/ (0,jsx_runtime.jsx)(IpdPrescriptionWritingView/* IpdPrescriptionWritingView */.X, {
                            entityQr: props.cookieEntityQr,
                            isEditable: false,
                            qrCode: props.data.clientQr,
                            id: props.data.presId
                        })
                    ]
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/ipd/TimelineView.tsx











var TimelineView = function(props) {
    var fetchAuditTrail = function fetchAuditTrail() {
        axios_default().get("/api/backend/ipd/case/audit/fetch/all/" + props.cookieEntityQr + "/" + props.case.id).then(function(resp) {
            console.log(JSON.stringify(resp.data));
            setAuditEntries(resp.data);
        }).catch(function(err) {
            console.error(err);
            if (err.response && err.response.status && err.response.status === 403) {
                (0,utils/* handleLogout */.hY)();
            }
        });
    };
    var ref = (0,react.useState)(false), loading = ref[0], setLoading = ref[1];
    var ref1 = (0,react.useState)([]), auditEntries = ref1[0], setAuditEntries = ref1[1];
    (0,react.useEffect)(function() {
        if (props.cookieEntityQr && props.case) {
            fetchAuditTrail();
        }
    }, [
        props.cookieEntityQr,
        props.case,
        props.stateTracker
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_es6.VerticalTimeline, {
            layout: "",
            lineColor: "#5A5A5A",
            children: auditEntries.map(function(entry) {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        entry.type == "SERVICE" && /*#__PURE__*/ (0,jsx_runtime.jsx)(RecordView, {
                            uhid: props.case.uhid,
                            cookieEntityQr: props.cookieEntityQr,
                            data: entry,
                            reloadMethod: fetchAuditTrail,
                            caseStatus: props.caseStatus,
                            referringDr: props.case && props.case.assignedDr
                        }, entry.id),
                        entry.type == "PROCEDURE" && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProcedureView, {
                            cookieEntityQr: props.cookieEntityQr,
                            data: entry,
                            reloadMethod: fetchAuditTrail,
                            editMethod: props.editProcedure,
                            caseStatus: props.caseStatus
                        }, entry.id),
                        entry.type == "BED" && /*#__PURE__*/ (0,jsx_runtime.jsx)(BedView, {
                            cookieEntityQr: props.cookieEntityQr,
                            data: entry,
                            reloadMethod: fetchAuditTrail,
                            caseStatus: props.caseStatus
                        }, entry.id),
                        entry.type == "VISIT" && /*#__PURE__*/ (0,jsx_runtime.jsx)(VisitView, {
                            cookieEntityQr: props.cookieEntityQr,
                            data: entry,
                            reloadMethod: fetchAuditTrail,
                            editMethod: props.editVisit,
                            caseStatus: props.caseStatus
                        }, entry.id),
                        props.caseStatus != "ACTIVE" && entry.type == "DISCHARGE_SUMMARY" && /*#__PURE__*/ (0,jsx_runtime.jsx)(DischargeView, {
                            cookieEntityQr: props.cookieEntityQr,
                            data: entry,
                            caseData: props.case
                        })
                    ]
                });
            })
        })
    });
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(70655);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Card.js + 2 modules
var Card = __webpack_require__(78182);
// EXTERNAL MODULE: ./node_modules/react-bootstrap-typeahead/es/index.js + 64 modules
var es = __webpack_require__(82584);
// EXTERNAL MODULE: ./components/customer/category/PatientDetailsView.tsx + 1 modules
var PatientDetailsView = __webpack_require__(47147);
// EXTERNAL MODULE: ./components/customer/category/PatientPreconditionsView.tsx
var PatientPreconditionsView = __webpack_require__(12390);
// EXTERNAL MODULE: ./components/common/CustomTypeahead.tsx
var CustomTypeahead = __webpack_require__(70058);
;// CONCATENATED MODULE: ./components/ipd/CaseDetailsView.tsx















var CaseDetailsView = function(props) {
    var fetchInsurances = function fetchInsurances() {
        axios_default().get("/api/backend/ipd/insurance/provider/fetch/all/" + props.cookieEntityQr).then(function(resp) {
            console.log(JSON.stringify(resp.data));
            if (resp.data) {
                setInsurances(resp.data);
            }
        }).catch(function(err) {
            console.error(err);
            if (err.response && err.response.status && err.response.status === 403) {
                (0,utils/* handleLogout */.hY)();
            }
        });
    };
    var fetchDiagnosisList = function fetchDiagnosisList() {
        axios_default().get("/api/backend/patient/condition/" + props.cookieEntityQr + "/DIAGNOSIS").then(function(resp) {
            console.log(JSON.stringify(resp.data));
            setDiagnosisList(resp.data.map(function(v) {
                return v.name;
            }));
        }).catch(function(err) {
            console.error(err);
            if (err.response && err.response.status && err.response.status === 403) {
                (0,utils/* handleLogout */.hY)();
            }
        });
    };
    var fetchCase = function fetchCase() {
        axios_default().get("/api/backend/ipd/case/fetch/" + props.cookieEntityQr + "/" + props.caseNumber).then(function(resp) {
            console.log(JSON.stringify(resp.data));
            setFormData(resp.data);
            if (resp.data.caseDetails) setCaseDetailsJson(JSON.parse(resp.data.caseDetails));
            setUhid(resp.data.uhid);
            setSelectedPackage(packages.filter(function(p) {
                return p.id == resp.data.packageId;
            }));
        }).catch(function(err) {
            console.error(err);
            if (err.response && err.response.status && err.response.status === 403) {
                (0,utils/* handleLogout */.hY)();
            }
        });
    };
    var fetchPackages = function fetchPackages() {
        axios_default().get("/api/backend/packages/entity_qr/" + props.cookieEntityQr).then(function(resp) {
            console.log(JSON.stringify(resp.data));
            if (resp.data) {
                setPackages(resp.data);
            }
        }).catch(function(err) {
            console.error(err);
            if (err.response && err.response.status && err.response.status === 403) {
                (0,utils/* handleLogout */.hY)();
            }
        });
    };
    var postAction = function postAction(uhid) {
        if (file) {
            uploadFile().then(function(resp) {
                console.log(resp);
                saveData(resp, uhid);
            }).catch(function(err) {
                console.error(err);
                if (err.response && err.response.status && err.response.status === 403) {
                    (0,utils/* handleLogout */.hY)();
                }
                setErrorMessage("Error while uploading the file");
                setLoading(false);
            });
        } else {
            saveData(null, uhid);
        }
        saveEvents(uhid);
    };
    var saveEvents = function saveEvents(uhid) {
        if (uhid != null && events != null) {
            axios_default().post("/api/backend/customers/save/" + uhid + "/events", events).then(function(resp) {
                console.log(JSON.stringify(resp.data));
            }).catch(function(err) {
                console.error(err);
                if (err.response && err.response.status && err.response.status === 403) {
                    (0,utils/* handleLogout */.hY)();
                }
            });
        } else {
            setErrorMessage("* Please enter the correct details of the patient");
        }
    };
    var saveData = function saveData(photoIdUrl, uhid) {
        if (formData["accompByNumber"] != null && !(0,utils/* validatePhoneNumber */.Y0)(formData["accompByNumber"])) {
            setErrorMessage("Please provide valid phone number");
            setLoading(false);
            return;
        }
        if (props.caseNumber) {
            axios_default().post("/api/backend/ipd/case/update/" + formData["id"], (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, formData), {
                caseDetails: JSON.stringify(caseDetailsJson),
                entityQr: props.cookieEntityQr,
                photoIdUrl: photoIdUrl,
                paymentMode: formData["policyNumber"] ? "INSURANCE" : "SELF",
                photoIdType: formData["photoIdType"] ? formData["photoIdType"] : "AADHAR",
                assignedDr: formData["assignedDr"] ? formData["assignedDr"] : props.doctors[0]["clientName"],
                assignedDrId: formData["assignedDrId"] ? formData["assignedDrId"] : props.doctors[0]["id"],
                packageId: selectedPackage.length > 0 ? selectedPackage[0].id : 0
            })).then(function(resp) {
                props.postAction();
                console.log(resp.data);
                setSuccessMessage("Data Saved");
            }).catch(function(err) {
                setErrorMessage("Please specify all mandatory fields correctly.");
                console.error(err);
                if (err.response && err.response.status && err.response.status === 403) {
                    (0,utils/* handleLogout */.hY)();
                }
            }).finally(function() {
                return setLoading(false);
            });
        } else {
            axios_default().post("/api/backend/ipd/case/create", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, formData), {
                caseDetails: JSON.stringify(caseDetailsJson),
                uhid: uhid,
                entityQr: props.cookieEntityQr,
                photoIdUrl: photoIdUrl,
                paymentMode: formData["policyNumber"] ? "INSURANCE" : "SELF",
                photoIdType: formData["photoIdType"] ? formData["photoIdType"] : "AADHAR",
                assignedDr: formData["assignedDr"] ? formData["assignedDr"] : props.doctors[0]["clientName"],
                assignedDrId: formData["assignedDrId"] ? formData["assignedDrId"] : props.doctors[0]["id"],
                packageId: selectedPackage.length > 0 ? selectedPackage[0].id : 0
            })).then(function(resp) {
                props.postAction();
                console.log(resp.data);
            }).catch(function(err) {
                setErrorMessage("Please specify all mandatory fields correctly.");
                console.error(err);
                if (err.response && err.response.status && err.response.status === 403) {
                    (0,utils/* handleLogout */.hY)();
                }
            }).finally(function() {
                return setLoading(false);
            });
        }
    };
    var getBasicInfo = function getBasicInfo() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default */.Z, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default.Header */.Z.Header, {
                    className: "bg-info bg-opacity-75 fw-bold text-white",
                    children: "Basic Info"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default.Body */.Z.Body, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PatientDetailsView/* PatientDetailsView */.H, {
                            ref: childRef,
                            category: "IPD",
                            uhid: uhid,
                            postAction: postAction,
                            updateEvents: setEvents
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "row",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col col-12 col-lg-6",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default.Group */.Z.Group, {
                                        className: "mb-3",
                                        controlId: "accompBy",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Label */.Z.Label, {
                                                className: "fs-7 text-secondary",
                                                children: "Accompanying Person's Name"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Control */.Z.Control, {
                                                value: formData["accompBy"],
                                                onChange: handleChange,
                                                size: "sm",
                                                name: "accompBy",
                                                type: "text",
                                                placeholder: "Enter Accompanying Person's Name"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col col-12 col-lg-6",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default.Group */.Z.Group, {
                                        className: "mb-3",
                                        controlId: "accompByNumber",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Label */.Z.Label, {
                                                className: "fs-7 text-secondary",
                                                children: "Accompanying Person's Mobile"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Control */.Z.Control, {
                                                value: formData["accompByNumber"],
                                                onChange: handleChange,
                                                size: "sm",
                                                name: "accompByNumber",
                                                type: "tel",
                                                placeholder: "Enter Accompanying Person's Mobile"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col col-12 col-lg-6",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default.Group */.Z.Group, {
                                        className: "mb-3",
                                        controlId: "type",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Label */.Z.Label, {
                                                className: "fs-7 text-secondary",
                                                children: "Type"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default.Select */.Z.Select, {
                                                className: "form-select form-select-sm",
                                                value: formData["photoIdType"],
                                                name: "photoIdType",
                                                onChange: function(e) {
                                                    return handleChange(e);
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                        value: "AADHAR",
                                                        children: "AADHAR"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                        value: "DL",
                                                        children: "DL"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                        value: "PAN",
                                                        children: "PAN"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                        value: "OTHER",
                                                        children: "OTHER"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col col-12 col-lg-6",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default.Group */.Z.Group, {
                                        className: "mb-3",
                                        controlId: "photoId",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Label */.Z.Label, {
                                                className: "fs-7 text-secondary",
                                                children: "Photo Id"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Control */.Z.Control, {
                                                value: formData["photoId"],
                                                onChange: handleChange,
                                                name: "photoId",
                                                size: "sm",
                                                type: "text",
                                                placeholder: "Enter Id"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col col-12 col-lg-6",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default.Group */.Z.Group, {
                                        className: "mb-3",
                                        controlId: "file",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Label */.Z.Label, {
                                                className: "fs-7 text-secondary",
                                                children: "File"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                type: "file",
                                                ref: componentRef,
                                                className: "form-control form-select form-select-sm",
                                                accept: ".doc,.docx,.HEIC,.HEIC,.HEVC,image/*,application/pdf",
                                                onChange: handleFileChange
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col col-12 col-md-6 col-lg-4",
                                    children: formData["photoIdUrl"] && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default.Group */.Z.Group, {
                                        className: "mb-3",
                                        controlId: "photoIdUrlDownload",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Label */.Z.Label, {
                                                className: "fs-7 text-secondary",
                                                children: "Download"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                target: "_blank",
                                                rel: "noreferrer",
                                                href: "/api/s3/download/?file=" + formData["photoIdUrl"],
                                                className: "text-success font-weight-bold",
                                                children: " ↓"
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        });
    };
    var getBillingInfo = function getBillingInfo() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default */.Z, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default.Header */.Z.Header, {
                    className: "bg-info bg-opacity-75 fw-bold text-white",
                    children: "Billing Info"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default.Body */.Z.Body, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "row",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col col-12 col-lg-6",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default.Group */.Z.Group, {
                                    className: "mb-3",
                                    controlId: "number",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Label */.Z.Label, {
                                            className: "fs-7 text-secondary",
                                            children: "Insurance TPA / Self"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default.Select */.Z.Select, {
                                            className: "form-select",
                                            size: "sm",
                                            value: formData["insuranceProviderId"],
                                            name: "insuranceProviderId",
                                            onChange: function(e) {
                                                return handleChange(e);
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                    value: 0,
                                                    children: "Self Payment"
                                                }, 0),
                                                insurances.map(function(insurance) {
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                        value: insurance.id,
                                                        children: insurance.tpa
                                                    }, insurance.id);
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col col-12 col-lg-6",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default.Group */.Z.Group, {
                                    className: "mb-3",
                                    controlId: "policyNumber",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Label */.Z.Label, {
                                            className: "fs-7 text-secondary",
                                            children: "Policy Id"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Control */.Z.Control, {
                                            value: formData["policyNumber"],
                                            onChange: handleChange,
                                            size: "sm",
                                            name: "policyNumber",
                                            type: "text",
                                            placeholder: "Enter Policy Id"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col col-12 col-lg-6",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default.Group */.Z.Group, {
                                    className: "mb-3",
                                    controlId: "packageInfo",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Label */.Z.Label, {
                                            className: "fs-7 text-secondary",
                                            children: "Package Opted"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Typeahead */.pY, {
                                            clearButton: true,
                                            labelKey: "name",
                                            size: "sm",
                                            className: "flex-fill",
                                            onChange: setSelectedPackage,
                                            selected: selectedPackage,
                                            options: packages,
                                            placeholder: "Search Package..."
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                })
            ]
        });
    };
    var getMedicalInfo = function getMedicalInfo() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default */.Z, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default.Header */.Z.Header, {
                    className: "bg-info bg-opacity-75 fw-bold text-white",
                    children: "Medical Info"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default.Body */.Z.Body, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "row",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "col col-12 col-lg-6",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default.Label */.Z.Label, {
                                        className: "fs-7 text-secondary",
                                        children: [
                                            "Doctor In-charge",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "text-danger",
                                                children: "*"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("select", {
                                        className: "form-select form-select-sm",
                                        value: formData["assignedDrId"] + " - " + formData["assignedDr"],
                                        onChange: function(e) {
                                            return handleDoctorAssigned(e);
                                        },
                                        children: props.doctors.map(function(profile, index) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                value: profile["id"] + " - " + profile["clientName"],
                                                children: profile["clientName"]
                                            }, "docs_" + profile["qrCode"]);
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col col-12 col-lg-6",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default.Group */.Z.Group, {
                                    className: "mb-3",
                                    controlId: "purpose",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Label */.Z.Label, {
                                            className: "text-secondary fs-7",
                                            children: "Purpose of Admission"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Control */.Z.Control, {
                                            value: formData["purpose"],
                                            onChange: handleChange,
                                            size: "sm",
                                            name: "purpose",
                                            placeholder: "Enter the purpose for Admission"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col col-12 col-lg-6",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default.Group */.Z.Group, {
                                    className: "mb-3",
                                    controlId: "cc",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Label */.Z.Label, {
                                            className: "text-secondary fs-7",
                                            children: "Chief Complaints"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Control */.Z.Control, {
                                            value: caseDetailsJson["cc"],
                                            as: "textarea",
                                            rows: 6,
                                            onChange: handlePatientDetailsChange,
                                            size: "sm",
                                            name: "cc"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col col-12 col-lg-6",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default.Group */.Z.Group, {
                                    className: "mb-3",
                                    controlId: "hpi",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Label */.Z.Label, {
                                            className: "text-secondary fs-7",
                                            children: "History of Present Ilness"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Control */.Z.Control, {
                                            value: caseDetailsJson["hpi"],
                                            as: "textarea",
                                            rows: 6,
                                            onChange: handlePatientDetailsChange,
                                            size: "sm",
                                            name: "hpi"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col col-12 col-lg-6",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default.Group */.Z.Group, {
                                    className: "mb-3",
                                    controlId: "personal_history",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Label */.Z.Label, {
                                            className: "text-secondary fs-7",
                                            children: "Personal History"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Control */.Z.Control, {
                                            value: caseDetailsJson["personal_history"],
                                            as: "textarea",
                                            rows: 6,
                                            onChange: handlePatientDetailsChange,
                                            size: "sm",
                                            name: "personal_history"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col col-12 col-lg-6",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default.Group */.Z.Group, {
                                    className: "mb-3",
                                    controlId: "birth_history",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Label */.Z.Label, {
                                            className: "text-secondary fs-7",
                                            children: "Birth/Family History"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Control */.Z.Control, {
                                            value: caseDetailsJson["birth_history"],
                                            as: "textarea",
                                            rows: 6,
                                            onChange: handlePatientDetailsChange,
                                            size: "sm",
                                            name: "birth_history"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col col-12 col-lg-6",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default.Group */.Z.Group, {
                                    className: "mb-3",
                                    controlId: "drug_allergy",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Label */.Z.Label, {
                                            className: "text-secondary fs-7",
                                            children: "Drug Allergy"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Control */.Z.Control, {
                                            value: caseDetailsJson["drug_allergy"],
                                            as: "textarea",
                                            rows: 6,
                                            onChange: handlePatientDetailsChange,
                                            size: "sm",
                                            name: "drug_allergy"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col col-12 col-lg-6",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default.Group */.Z.Group, {
                                    className: "mb-3",
                                    controlId: "treatment_history",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Label */.Z.Label, {
                                            className: "text-secondary fs-7",
                                            children: "Treatment History"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Control */.Z.Control, {
                                            value: caseDetailsJson["treatment_history"],
                                            as: "textarea",
                                            rows: 6,
                                            onChange: handlePatientDetailsChange,
                                            size: "sm",
                                            name: "treatment_history"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col col-12 mb-3",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PatientPreconditionsView/* PatientPreconditionsView */.O, {
                                    entityQr: props.cookieEntityQr,
                                    category: "General Physician",
                                    isEditable: true,
                                    preconditions: events,
                                    labelStyle: "text-secondary fs-7",
                                    updatePreconditions: function(e) {
                                        setEvents(e);
                                    },
                                    stacked: true
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col col-12",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default.Group */.Z.Group, {
                                    className: "mb-3",
                                    controlId: "diagnosis",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Label */.Z.Label, {
                                            className: "fs-7 text-secondary",
                                            children: "Diagnosis"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomTypeahead/* CustomTypeahead */.v, {
                                            selected: formData["diagnosis"] ? [
                                                formData["diagnosis"]
                                            ] : [],
                                            onChange: function(e) {
                                                setFormData((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, formData), {
                                                    diagnosis: e[0]
                                                }));
                                            },
                                            options: diagnosisList,
                                            placeholder: "Type to select...",
                                            size: "sm",
                                            setNewValues: handleAddDiagnosis
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                })
            ]
        });
    };
    var getItemForm = function getItemForm() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "row",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "col col-12 col-xl-6",
                        children: [
                            getBasicInfo(),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            getBillingInfo()
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col col-12 col-xl-6",
                        children: getMedicalInfo()
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "col col-12",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "pt-5",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                                    className: "text-white",
                                    variant: "info",
                                    type: "submit",
                                    onClick: handleSubmit,
                                    children: [
                                        loading && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "text-center",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "spinner-border",
                                                role: "status"
                                            })
                                        }),
                                        !loading && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                            children: "Save"
                                        })
                                    ]
                                })
                            }),
                            successMessage && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-success fs-5",
                                children: successMessage
                            }),
                            errorMessage && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-danger fs-5",
                                children: errorMessage
                            })
                        ]
                    })
                ]
            })
        });
    };
    var ref = (0,react.useState)(false), loading = ref[0], setLoading = ref[1];
    var ref1 = (0,react.useState)({}), formData = ref1[0], setFormData = ref1[1];
    var ref2 = (0,react.useState)({}), caseDetailsJson = ref2[0], setCaseDetailsJson = ref2[1];
    var ref3 = (0,react.useState)(null), successMessage = ref3[0], setSuccessMessage = ref3[1];
    var ref4 = (0,react.useState)(null), errorMessage = ref4[0], setErrorMessage = ref4[1];
    var ref5 = (0,react.useState)([]), packages = ref5[0], setPackages = ref5[1];
    var ref6 = (0,react.useState)([]), selectedPackage = ref6[0], setSelectedPackage = ref6[1];
    var ref7 = (0,react.useState)([]), insurances = ref7[0], setInsurances = ref7[1];
    var ref8 = (0,react.useState)(null), uhid = ref8[0], setUhid = ref8[1];
    var ref9 = (0,react.useState)([]), events = ref9[0], setEvents = ref9[1];
    var ref10 = (0,react.useState)([]), diagnosisList = ref10[0], setDiagnosisList = ref10[1];
    var childRef = (0,react.useRef)(null);
    var handleAddDiagnosis = function(condition) {
        axios_default().post("/api/backend/patient/condition/create/" + props.cookieEntityQr, {
            name: condition,
            type: "DIAGNOSIS",
            category: "General Physician"
        }).then(function(resp) {
            console.log(JSON.stringify(resp.data));
        }).catch(function(err) {
            console.error(err);
            if (err.response && err.response.status && err.response.status === 403) {
                (0,utils/* handleLogout */.hY)();
            }
            setErrorMessage("* Something went wrong!");
        });
    };
    var ref11 = (0,react.useState)(), file = ref11[0], setFile = ref11[1];
    var componentRef = (0,react.useRef)(null);
    var handleFileChange = function(event) {
        setErrorMessage(null);
        if (event.target.files && event.target.files[0]) {
            var selectedFile = event.target.files[0];
            if (selectedFile.size > 6000000) {
                setErrorMessage("File size should be less than 5 MB");
            } else {
                setFile(selectedFile);
            }
        }
    };
    var uploadFile = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var key, data, _tmp, url, ref, newData, _tmp1;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        key = props.cookieEntityQr + "_" + (0,utils/* randomString */.O1)() + "_" + file.name;
                        _tmp = {};
                        return [
                            4,
                            axios_default().post("/api/s3/upload", (_tmp.name = key, _tmp.type = file.type, _tmp))
                        ];
                    case 1:
                        data = _state.sent().data;
                        console.log(data);
                        url = data.url;
                        _tmp1 = {};
                        return [
                            4,
                            axios_default().put(url, file, (_tmp1.headers = {
                                "Content-type": file.type,
                                "Access-Control-Allow-Origin": "*"
                            }, _tmp1))
                        ];
                    case 2:
                        ref = _state.sent(), newData = ref.data;
                        console.log(newData);
                        return [
                            2,
                            key
                        ];
                }
            });
        });
        return function uploadFile() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleSubmit = function(e) {
        e.preventDefault();
        setLoading(true);
        setErrorMessage(null);
        setSuccessMessage(null);
        childRef.current.handleDataSubmit();
    };
    var handleChange = function(e) {
        setFormData((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, formData), (0,_define_property/* default */.Z)({}, e.target.name, e.target.value)));
    };
    var handlePatientDetailsChange = function(e) {
        setCaseDetailsJson((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, caseDetailsJson), (0,_define_property/* default */.Z)({}, e.target.name, e.target.value)));
    };
    var handleDoctorAssigned = function(e) {
        setFormData((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, formData), {
            "assignedDr": e.target.value.split(" - ")[1],
            "assignedDrId": e.target.value.split(" - ")[0]
        }));
    };
    (0,react.useEffect)(function() {
        if (props.caseNumber) {
            fetchCase();
        }
    }, [
        props.caseNumber,
        packages
    ]);
    (0,react.useEffect)(function() {
        if (props.createForUhid) {
            setUhid(props.createForUhid);
        }
    }, [
        props.createForUhid
    ]);
    (0,react.useEffect)(function() {
        fetchPackages();
        fetchInsurances();
        fetchDiagnosisList();
        setFormData((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, formData), {
            // Trimming any whitespace
            dob: new Date()
        }));
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: getItemForm()
    });
};

// EXTERNAL MODULE: ./components/inventory/billing/BillView.tsx + 3 modules
var BillView = __webpack_require__(61192);
// EXTERNAL MODULE: ./components/ipd/consentForms/RichEditor.tsx
var RichEditor = __webpack_require__(23080);
;// CONCATENATED MODULE: ./components/ipd/subCategories/visit/AddVisitView.tsx










var AddVisitView = function(props) {
    var getAddNewWidget = function getAddNewWidget() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "row",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col col-12",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "border",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "m-1",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Label */.Z.Label, {
                                                className: "text-info fs-7",
                                                children: "Vitals"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(PatientVitalsView/* PatientVitalsView */.d, {
                                                vitals: vitals,
                                                isEditable: true,
                                                updateVitals: updateVitals,
                                                qrCode: null
                                            })
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col col-12",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default.Group */.Z.Group, {
                                    className: "my-2",
                                    controlId: "notes",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Label */.Z.Label, {
                                            className: "text-info fs-7",
                                            children: "Visit Notes"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(RichEditor/* RichEditor */.E, {
                                            data: notes,
                                            setData: setNotes,
                                            height: 300
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "col col-12",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Label */.Z.Label, {
                                        className: "text-info fs-7",
                                        children: "Visiting Doctor"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Typeahead */.pY, {
                                        clearButton: true,
                                        labelKey: "clientName",
                                        className: "flex-fill",
                                        selected: drIncharge ? [
                                            drIncharge
                                        ] : [],
                                        onChange: function(e) {
                                            setDrIncharge(e && e.length > 0 ? e[0]["clientName"] : null);
                                            setQrCode(e && e.length > 0 ? e[0]["qrCode"] : null);
                                            setPrCategory(e && e.length > 0 ? e[0]["category"] : null);
                                        },
                                        options: props.doctors,
                                        placeholder: "Type to select Doctor...",
                                        size: "sm"
                                    })
                                ]
                            }),
                            qrCode && /*#__PURE__*/ (0,jsx_runtime.jsx)(IpdPrescriptionWritingView/* IpdPrescriptionWritingView */.X, {
                                entityQr: props.cookieEntityQr,
                                isEditable: true,
                                qrCode: qrCode,
                                id: prescId,
                                setLineItems: setLineItems
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "my-3",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                        className: "btn btn-info text-white btn-sm",
                                        onClick: function(e) {
                                            return handleAddVisit(e);
                                        },
                                        children: [
                                            loading && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "text-center",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "spinner-border",
                                                    role: "status"
                                                })
                                            }),
                                            !loading && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                children: "Add Visit Notes"
                                            })
                                        ]
                                    }),
                                    errorMessage && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "text-danger fs-6",
                                        children: [
                                            "*",
                                            errorMessage
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        });
    };
    var ref = (0,react.useState)(null), successMessage = ref[0], setSuccessMessage = ref[1];
    var ref1 = (0,react.useState)(false), loading = ref1[0], setLoading = ref1[1];
    var ref2 = (0,react.useState)(null), errorMessage = ref2[0], setErrorMessage = ref2[1];
    var ref3 = (0,react.useState)(null), drIncharge = ref3[0], setDrIncharge = ref3[1];
    var ref4 = (0,react.useState)(null), qrCode = ref4[0], setQrCode = ref4[1];
    var ref5 = (0,react.useState)(null), prCategory = ref5[0], setPrCategory = ref5[1];
    var ref6 = (0,react.useState)(null), prescId = ref6[0], setPrescId = ref6[1];
    var ref7 = (0,react.useState)(null), vitals = ref7[0], updateVitals = ref7[1];
    var ref8 = (0,react.useState)([]), lineItems = ref8[0], setLineItems = ref8[1];
    var ref9 = (0,react.useState)(null), notes = ref9[0], setNotes = ref9[1];
    (0,react.useEffect)(function() {
        if (props.visitData) {
            setDrIncharge(props.visitData.drInCharge);
            setNotes(props.visitData.notes);
            setQrCode(props.visitData.clientQr);
            setPrescId(props.visitData.presId);
            updateVitals(props.visitData.vitals && JSON.parse(props.visitData.vitals));
        }
    }, [
        props.visitData
    ]);
    (0,react.useEffect)(function() {
        if (props.doctors && props.doctors.length == 1 && props.visitData && !props.visitData.drInCharge) {
            setDrIncharge(props.doctors[0]["clientName"]);
            setQrCode(props.doctors[0]["qrCode"]);
            setPrCategory(props.doctors[0]["category"]);
        }
    }, [
        props.doctors
    ]);
    var handleAddVisit = function(e) {
        e.preventDefault();
        if (props.visitData && props.visitData.id) {
            axios_default().post("/api/backend/ipd/case/audit/update/" + props.visitData.id, {
                entityQr: props.cookieEntityQr,
                caseId: props.caseId,
                drInCharge: drIncharge,
                notes: notes,
                type: "VISIT",
                clientQr: qrCode,
                vitals: vitals && JSON.stringify(vitals),
                lineItems: lineItems,
                prCategory: prCategory
            }).then(function(resp) {
                console.log(resp.data);
                props.postAction();
            }).catch(function(err) {
                setErrorMessage("Error while creating the audit trail");
                console.error(err);
                if (err.response && err.response.status && err.response.status === 403) {
                    (0,utils/* handleLogout */.hY)();
                }
            }).finally(function() {
                return setLoading(false);
            });
        } else {
            axios_default().post("/api/backend/ipd/case/audit/create/", {
                entityQr: props.cookieEntityQr,
                caseId: props.caseId,
                drInCharge: drIncharge,
                notes: notes,
                type: "VISIT",
                clientQr: qrCode,
                vitals: vitals && JSON.stringify(vitals),
                lineItems: lineItems,
                prCategory: prCategory
            }).then(function(resp) {
                console.log(resp.data);
                props.postAction();
            }).catch(function(err) {
                setErrorMessage("Error while creating the audit trail");
                console.error(err);
                if (err.response && err.response.status && err.response.status === 403) {
                    (0,utils/* handleLogout */.hY)();
                }
            }).finally(function() {
                return setLoading(false);
            });
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: getAddNewWidget()
    });
};

// EXTERNAL MODULE: ./components/ipd/subCategories/DischargeSummary.tsx
var DischargeSummary = __webpack_require__(56496);
// EXTERNAL MODULE: ./components/ipd/subCategories/records/AddRecordView.tsx
var AddRecordView = __webpack_require__(54242);
;// CONCATENATED MODULE: ./components/ipd/subCategories/procedure/AddProcedureView.tsx








var AddProcedureView = function(props) {
    var fetchServices = function fetchServices() {
        axios_default().get("/api/backend/inventory/item/fetch/all/" + props.cookieEntityQr + "?type=SERVICE&category=Medical Procedures").then(function(resp) {
            console.log(JSON.stringify(resp.data));
            setServices(resp.data);
            if (resp.data && resp.data.length > 0) setProcedureName(resp.data[0].name);
        }).catch(function(err) {
            console.error(err);
            if (err.response && err.response.status && err.response.status === 403) {
                (0,utils/* handleLogout */.hY)();
            }
        });
    };
    var getAddNewWidget = function getAddNewWidget() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "row",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "col col-12 my-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Label */.Z.Label, {
                                        className: "text-info fs-7",
                                        children: "Procedure / Surgery"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Typeahead */.pY, {
                                        clearButton: true,
                                        labelKey: "name",
                                        className: "flex-fill",
                                        selected: procedureName ? [
                                            procedureName
                                        ] : [],
                                        onChange: function(e) {
                                            setProcedureName(e && e.length > 0 ? e[0]["name"] : null);
                                        },
                                        options: services,
                                        placeholder: "Type to select Procedure...",
                                        size: "sm"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "col col-12 my-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Label */.Z.Label, {
                                        className: "text-info fs-7",
                                        children: "Doctor In-Charge"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Typeahead */.pY, {
                                        clearButton: true,
                                        labelKey: "clientName",
                                        className: "flex-fill",
                                        selected: drIncharge ? [
                                            drIncharge
                                        ] : [],
                                        onChange: function(e) {
                                            setDrIncharge(e && e.length > 0 ? e[0]["clientName"] : null);
                                        },
                                        options: props.doctors,
                                        placeholder: "Type to select Doctor...",
                                        size: "sm"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col col-12",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default.Group */.Z.Group, {
                                    className: "my-2",
                                    controlId: "procedureDetails",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Label */.Z.Label, {
                                            className: "text-info fs-7",
                                            children: "Procedure Details"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(RichEditor/* RichEditor */.E, {
                                            data: procedureDetails,
                                            setData: setProcedureDetails,
                                            height: 400
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "my-32",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                        className: "btn btn-info text-white btn-sm",
                                        onClick: function(e) {
                                            return handleAddProcedure(e);
                                        },
                                        children: [
                                            loading && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "text-center",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "spinner-border",
                                                    role: "status"
                                                })
                                            }),
                                            !loading && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                children: "Add Procedure"
                                            })
                                        ]
                                    }),
                                    errorMessage && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "text-danger fs-6",
                                        children: [
                                            "*",
                                            errorMessage
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        });
    };
    var ref = (0,react.useState)(null), successMessage = ref[0], setSuccessMessage = ref[1];
    var ref1 = (0,react.useState)(false), loading = ref1[0], setLoading = ref1[1];
    var ref2 = (0,react.useState)(null), errorMessage = ref2[0], setErrorMessage = ref2[1];
    var ref3 = (0,react.useState)(props.doctors && props.doctors[0]["clientName"]), drIncharge = ref3[0], setDrIncharge = ref3[1];
    var ref4 = (0,react.useState)(), procedureName = ref4[0], setProcedureName = ref4[1];
    var ref5 = (0,react.useState)("Assisting Doctors : \n" + "Anaesthetist : \n" + "Anaesthesia : \n" + "Type of Anaesthesia : \n" + "\n" + "Details : \n" + "\n" + "Operation Notes : "), procedureDetails = ref5[0], setProcedureDetails = ref5[1];
    var ref6 = (0,react.useState)(), services = ref6[0], setServices = ref6[1];
    (0,react.useEffect)(function() {
        if (props.procedureData) {
            setProcedureName(props.procedureData.procedureName);
            setProcedureDetails(props.procedureData.procedureDetails);
            setDrIncharge(props.procedureData.drInCharge);
        }
    }, [
        props.procedureData
    ]);
    (0,react.useEffect)(function() {
        if (props.cookieEntityQr) {
            fetchServices();
        }
    }, [
        props.cookieEntityQr
    ]);
    var handleAddProcedure = function(e) {
        e.preventDefault();
        var itemId = services.filter(function(s) {
            return s.name == procedureName;
        })[0].id;
        if (props.procedureData && props.procedureData.id) {
            axios_default().post("/api/backend/ipd/case/audit/update/" + props.procedureData.id, {
                entityQr: props.cookieEntityQr,
                caseId: props.caseId,
                drInCharge: drIncharge != null ? drIncharge : props.doctors && props.doctors[0]["clientName"],
                procedureName: procedureName,
                procedureDetails: procedureDetails,
                itemId: itemId,
                type: "PROCEDURE"
            }).then(function(resp) {
                console.log(resp.data);
                props.postAction();
            }).catch(function(err) {
                setErrorMessage("Error while creating the audit trail");
                console.error(err);
                if (err.response && err.response.status && err.response.status === 403) {
                    (0,utils/* handleLogout */.hY)();
                }
            }).finally(function() {
                return setLoading(false);
            });
        } else {
            axios_default().post("/api/backend/ipd/case/audit/create/", {
                entityQr: props.cookieEntityQr,
                caseId: props.caseId,
                drInCharge: drIncharge != null ? drIncharge : props.doctors && props.doctors[0]["clientName"],
                procedureName: procedureName,
                procedureDetails: procedureDetails,
                itemId: itemId,
                type: "PROCEDURE"
            }).then(function(resp) {
                console.log(resp.data);
                props.postAction();
            }).catch(function(err) {
                setErrorMessage("Error while creating the audit trail");
                console.error(err);
                if (err.response && err.response.status && err.response.status === 403) {
                    (0,utils/* handleLogout */.hY)();
                }
            }).finally(function() {
                return setLoading(false);
            });
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: getAddNewWidget()
    });
};

;// CONCATENATED MODULE: ./components/ipd/subCategories/bed/AddBedView.tsx






var AddBedView = function(props) {
    var fetchBeds = function fetchBeds() {
        axios_default().get("/api/backend/inventory/item/fetch/all/" + props.cookieEntityQr + "?type=SERVICE&category=Beds&excludeZero=true").then(function(resp) {
            console.log(JSON.stringify(resp.data));
            setAvailableBeds(resp.data);
            if (resp.data && resp.data.length > 0) setBedId(resp.data[0].id);
        }).catch(function(err) {
            console.error(err);
            if (err.response && err.response.status && err.response.status === 403) {
                (0,utils/* handleLogout */.hY)();
            }
        });
    };
    var getAddNewWidget = function getAddNewWidget() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "mt-3"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "row",
                            children: [
                                assignedBed && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col col-12",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "d-flex gap-5 mb-5",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "text-secondary fs-7",
                                                children: [
                                                    "Assigned Bed: ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "fs-5 text-primary",
                                                        children: assignedBed
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                className: "btn btn-warning text-white btn-sm",
                                                onClick: function(e) {
                                                    return handleUnassignBed(e);
                                                },
                                                children: [
                                                    loading && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "text-center",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "spinner-border",
                                                            role: "status"
                                                        })
                                                    }),
                                                    !loading && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                        children: "Unsssign Bed"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "col col-12",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "text-secondary",
                                            children: "Select Bed:"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("select", {
                                            className: "form-select my-2 form-select-sm",
                                            value: bedId,
                                            onChange: function(e) {
                                                setBedId(e.target.value);
                                            },
                                            children: availableBeds && availableBeds.map(function(service) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                    value: service.id,
                                                    children: service.name
                                                }, service.name);
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "my-3",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                            className: "btn btn-info text-white btn-sm",
                                            onClick: function(e) {
                                                return handleAddBed(e);
                                            },
                                            children: [
                                                loading && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "text-center",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "spinner-border",
                                                        role: "status"
                                                    })
                                                }),
                                                !loading && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                    children: "Assign New Bed"
                                                })
                                            ]
                                        }),
                                        errorMessage && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "text-danger fs-6",
                                            children: [
                                                "*",
                                                errorMessage
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            ]
        });
    };
    var ref = (0,react.useState)(null), successMessage = ref[0], setSuccessMessage = ref[1];
    var ref1 = (0,react.useState)(false), loading = ref1[0], setLoading = ref1[1];
    var ref2 = (0,react.useState)(null), errorMessage = ref2[0], setErrorMessage = ref2[1];
    var ref3 = (0,react.useState)(), bedId = ref3[0], setBedId = ref3[1];
    var ref4 = (0,react.useState)(), availableBeds = ref4[0], setAvailableBeds = ref4[1];
    var ref5 = (0,react.useState)(), assignedBed = ref5[0], setAssignedBed = ref5[1];
    (0,react.useEffect)(function() {
        if (props.cookieEntityQr) {
            fetchBeds();
        }
    }, [
        props.cookieEntityQr
    ]);
    (0,react.useEffect)(function() {
        if (props.bedName) {
            setAssignedBed(props.bedName);
        }
    }, [
        props.bedName
    ]);
    var handleAddBed = function(e) {
        e.preventDefault();
        axios_default().post("/api/backend/ipd/case/audit/create/", {
            entityQr: props.cookieEntityQr,
            caseId: props.caseId,
            bedId: bedId,
            itemId: bedId,
            type: "BED"
        }).then(function(resp) {
            console.log(resp.data);
            props.postAction();
        }).catch(function(err) {
            setErrorMessage("Error while creating the audit trail");
            console.error(err);
            if (err.response && err.response.status && err.response.status === 403) {
                (0,utils/* handleLogout */.hY)();
            }
        }).finally(function() {
            return setLoading(false);
        });
    };
    var handleUnassignBed = function(e) {
        e.preventDefault();
        axios_default().post("/api/backend/ipd/case/audit/create/", {
            entityQr: props.cookieEntityQr,
            caseId: props.caseId,
            bedId: 0,
            itemId: 0,
            type: "BED"
        }).then(function(resp) {
            console.log(resp.data);
            props.postAction();
        }).catch(function(err) {
            setErrorMessage("Error while creating the audit trail");
            console.error(err);
            if (err.response && err.response.status && err.response.status === 403) {
                (0,utils/* handleLogout */.hY)();
            }
        }).finally(function() {
            return setLoading(false);
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: getAddNewWidget()
    });
};

// EXTERNAL MODULE: ./node_modules/nanoid/index.browser.js
var index_browser = __webpack_require__(53416);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/styled-jsx/style.js
var style = __webpack_require__(65988);
var style_default = /*#__PURE__*/__webpack_require__.n(style);
// EXTERNAL MODULE: ./node_modules/react-to-print/lib/index.js
var lib = __webpack_require__(47116);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);
;// CONCATENATED MODULE: ./components/diagnostics/lab/LabRecordsPrintView.tsx




var LabRecordsPrintView = /*#__PURE__*/ (0,react.forwardRef)(function(props, ref) {
    var fetchRecords = function fetchRecords() {
        axios_default().get("/api/backend/customer/records/fetch/all/" + props.uhid + "/" + props.visitId).then(function(resp) {
            var createdAt = new Date(Date.now());
            var updatedAt = new Date(Date.now());
            var atleastOneReport = false;
            console.log(JSON.stringify(resp));
            setRecords(resp.data.records.filter(function(r) {
                return r.category == "Lab";
            }).map(function(r) {
                r.data = JSON.parse(r.data);
                var thisCreatedAt = new Date(r.createdAt);
                var thisUpdatedAt = new Date(r.updatedAt);
                if (createdAt > thisCreatedAt) createdAt = thisCreatedAt;
                if (r.reportStatus == "AVAILABLE") atleastOneReport = true;
                if (r.reportStatus == "AVAILABLE" && updatedAt < thisUpdatedAt) updatedAt = thisUpdatedAt;
                return r;
            }));
            setCollectionDate(createdAt.toDateString());
            setReportDate(atleastOneReport ? updatedAt.toDateString() : null);
        }).catch(function(err) {
            console.error(err);
            if (err.response && err.response.status && err.response.status === 403) {
                (0,utils/* handleLogout */.hY)();
            }
        });
    };
    var fetchEntityDetails = function fetchEntityDetails() {
        axios_default().get("/api/backend/entity/profile/" + props.entityQr).then(function(resp) {
            console.log(JSON.stringify(resp.data));
            setEntityDetails(resp.data);
        }).catch(function(err) {
            console.error(err);
            if (err.response && err.response.status && err.response.status === 403) {
                (0,utils/* handleLogout */.hY)();
            }
        });
    };
    var outsideRange = function outsideRange(value, rangeStart, rangeEnd) {
        if (!isNaN(rangeStart) && !isNaN(rangeEnd) && !isNaN(value)) {
            return !(Number.parseFloat(value) >= Number.parseFloat(rangeStart) && Number.parseFloat(value) <= Number.parseFloat(rangeEnd));
        } else {
            return false;
        }
    };
    var ref1 = (0,react.useState)(), records = ref1[0], setRecords = ref1[1];
    var ref2 = (0,react.useState)(), entityDetails = ref2[0], setEntityDetails = ref2[1];
    var ref3 = (0,react.useState)(), patientDetails = ref3[0], setPatientDetails = ref3[1];
    var ref4 = (0,react.useState)(), collectionDate = ref4[0], setCollectionDate = ref4[1];
    var ref5 = (0,react.useState)(), reportDate = ref5[0], setReportDate = ref5[1];
    var ref6 = (0,react.useState)("border"), borderClass = ref6[0], setBorderClass = ref6[1];
    (0,react.useEffect)(function() {
        if (props.visitId) {
            fetchRecords();
        }
    }, [
        props.visitId,
        props.stateTracker
    ]);
    (0,react.useEffect)(function() {
        if (props.printHeader) {
            setBorderClass("");
        }
    }, [
        props.printHeader
    ]);
    (0,react.useEffect)(function() {
        if (props.entityQr) {
            fetchEntityDetails();
        }
    }, [
        props.entityQr
    ]);
    (0,react.useEffect)(function() {
        if (props.uhid != null) {
            axios_default().get("/api/backend/customers/fetch/" + props.uhid).then(function(resp) {
                console.log(JSON.stringify(resp.data));
                setPatientDetails(resp.data);
            }).catch(function(err) {
                console.error(err);
                if (err.response && err.response.status && err.response.status === 403) {
                    (0,utils/* handleLogout */.hY)();
                }
            });
        }
    }, [
        props.uhid
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: records && records.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "row printView",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "col col-12 my-2",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: borderClass,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "px-5 py-3",
                        children: [
                            props.printHeader && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "font-weight-bold fs-4 text-center",
                                        children: entityDetails && entityDetails.businessName
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "font-weight-bold fs-7 text-center",
                                        children: entityDetails && entityDetails.businessAddress
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "card my-2",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "row mx-2 my-2",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "col col-6",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("table", {
                                                        children: [
                                                            patientDetails && /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                        className: "text-secondary",
                                                                        children: "Name"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("td", {
                                                                        children: [
                                                                            ":\xa0\xa0",
                                                                            patientDetails.name
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            patientDetails && /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                        className: "text-secondary",
                                                                        children: "Mobile"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: "d-inline-block",
                                                                        children: [
                                                                            ":\xa0\xa0",
                                                                            patientDetails.mobile
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            patientDetails && patientDetails.age && /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                        className: "text-secondary",
                                                                        children: "Age"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("td", {
                                                                        children: [
                                                                            ":\xa0\xa0",
                                                                            patientDetails.age,
                                                                            "\xa0years"
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            patientDetails && patientDetails.gender && /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                        className: "text-secondary",
                                                                        children: "Gender"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("td", {
                                                                        children: [
                                                                            ":\xa0\xa0",
                                                                            patientDetails.gender
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            patientDetails && /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                        className: "text-secondary",
                                                                        children: "UHID"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("td", {
                                                                        children: [
                                                                            ":\xa0\xa0",
                                                                            patientDetails.uhid
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "col col-6",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("table", {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                        className: "text-secondary",
                                                                        children: "Sample Date"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("td", {
                                                                        children: [
                                                                            ":\xa0\xa0",
                                                                            new Date(collectionDate).toLocaleDateString("en-GB")
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            reportDate && /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                        className: "text-secondary",
                                                                        children: "Report Date"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("td", {
                                                                        children: [
                                                                            ":\xa0\xa0",
                                                                            new Date(reportDate).toLocaleDateString("en-GB")
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            props.referringDr && /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                        className: "text-secondary",
                                                                        children: "Referring Dr"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("td", {
                                                                        children: [
                                                                            ":\xa0\xa0",
                                                                            props.referringDr
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            records && records.map(function(record) {
                                {
                                    return record.data && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "my-4",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "text-decoration-underline mb-2",
                                                children: record.data.category
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("table", {
                                                        className: "table table-borderless",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("thead", {
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                                            children: "Name"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                                            children: "Result"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                                            children: "Unit"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                                            children: "Bio-reference range"
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("tbody", {
                                                                children: record.data.parameters && record.data.parameters.map(function(p, index) {
                                                                    if (p.result) {
                                                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                                    children: p.name
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                                    className: outsideRange(p.result, p.rangeStart, p.rangeEnd) ? "fw-bold" : "",
                                                                                    children: p.result
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                                    children: p.units
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                                    children: p.bioReference
                                                                                })
                                                                            ]
                                                                        }, "para" + index);
                                                                    }
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    record.data.notes && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "my-2 border border-1 border-dark pl-2",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                                                children: "Notes:"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "pl-2",
                                                                dangerouslySetInnerHTML: {
                                                                    __html: record.data.notes
                                                                }
                                                            })
                                                        ]
                                                    }),
                                                    record.data.comments && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "my-2 border border-1 border-dark pl-2",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                                                children: "Comments:"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "pl-2",
                                                                dangerouslySetInnerHTML: {
                                                                    __html: record.data.comments
                                                                }
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    });
                                }
                            }),
                            entityDetails && entityDetails.labIncharge && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "mt-5 fw-bold",
                                children: [
                                    "Lab incharge : ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "fw-normal",
                                        children: entityDetails.labIncharge
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        })
    });
});
LabRecordsPrintView.displayName = "LabRecordsPrintView";

// EXTERNAL MODULE: ./components/ipd/subCategories/CaseHeaderView.tsx
var CaseHeaderView = __webpack_require__(45400);
;// CONCATENATED MODULE: ./components/ipd/subCategories/CaseFile.tsx
"use client";














var CaseFile = function(props) {
    var fetchEvents = function fetchEvents(uhid) {
        axios_default().get("/api/backend/customers/fetch/" + uhid + "/events").then(function(resp) {
            console.log(JSON.stringify(resp.data));
            setEvents(resp.data);
        }).catch(function(err) {
            console.error(err);
            if (err.response && err.response.status && err.response.status === 403) {
                (0,utils/* handleLogout */.hY)();
            }
        });
    };
    var fetchAuditTrail = function fetchAuditTrail(caseId, entityQr) {
        axios_default().get("/api/backend/ipd/case/audit/fetch/all/" + entityQr + "/" + caseId).then(function(resp) {
            console.log(JSON.stringify(resp.data));
            setAuditEntries(resp.data);
            var dischargeEntry = resp.data.filter(function(entry) {
                return entry.type == "DISCHARGE_SUMMARY";
            });
            if (dischargeEntry && dischargeEntry.length > 0) {
                setDischargeDate(dischargeEntry[0].updatedAt);
            }
            resp.data.map(function(entry) {
                if (entry.type == "SERVICE") {
                    axios_default().get("/api/backend/customer/records/fetch/all/" + entry.id + "?isIpd=true").then(function(resp) {
                        console.log(JSON.stringify(resp.data));
                        resp.data.records.map(function(ar) {
                            setRecords(function(recs) {
                                var newRecs = (0,_to_consumable_array/* default */.Z)(recs);
                                if (recs.filter(function(r) {
                                    return r.medicalRecordId == ar.id;
                                }).length == 0) {
                                    newRecs.push((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, ar), {
                                        "medicalRecordId": ar.id
                                    }));
                                }
                                return newRecs;
                            });
                        });
                    }).catch(function(err) {
                        console.error(err);
                        if (err.response && err.response.status && err.response.status === 403) {
                            (0,utils/* handleLogout */.hY)();
                        }
                    });
                }
            });
        }).catch(function(err) {
            console.error(err);
            if (err.response && err.response.status && err.response.status === 403) {
                (0,utils/* handleLogout */.hY)();
            }
        });
    };
    var fetchCase = function fetchCase() {
        axios_default().get("/api/backend/ipd/case/fetch/" + props.caseId).then(function(resp) {
            console.log(JSON.stringify(resp.data));
            setCaseDetails(resp.data);
            if (props.doctors && props.doctors.filter(function(dr) {
                return dr.id == resp.data.assignedDrId;
            }).length > 0) {
                setAssignedDrQr(props.doctors.filter(function(dr) {
                    return dr.id == resp.data.assignedDrId;
                })[0]["qrCode"]);
            }
            if (resp.data.caseDetails) {
                setCaseDetailsJson(JSON.parse(resp.data.caseDetails));
            }
            fetchAuditTrail(resp.data.id, resp.data.entityQr);
            fetchEvents(resp.data.uhid);
        }).catch(function(err) {
            console.error(err);
            if (err.response && err.response.status && err.response.status === 403) {
                (0,utils/* handleLogout */.hY)();
            }
        });
    };
    var getDischargeSummaryView = function getDischargeSummaryView() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "d-flex justify-content-end",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "text-warning align-self-center",
                            children: "* Please scroll & print the uploaded documents seperately"
                        }),
                        "\xa0\xa0",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "align-self-center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((lib_default()), {
                                trigger: function() {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        className: "btn btn-outline-primary",
                                        children: "\uD83D\uDDA8 Case Summary"
                                    });
                                },
                                content: function() {
                                    return componentRef.current;
                                }
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    ref: componentRef,
                    className: "jsx-72c8f128dbbb05ec" + " " + "px-5",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "jsx-72c8f128dbbb05ec" + " " + "printElements",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "jsx-72c8f128dbbb05ec" + " " + "text-secondary text-center text-decoration-underline font-weight-bold fs-5 pb-3",
                                    children: [
                                        "Discharge Summary",
                                        caseDetails && caseDetails.patientStatus && caseDetails.patientStatus != "DISCHARGE" ? " - " + caseDetails.patientStatus : ""
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CaseHeaderView/* CaseHeaderView */.Q, {
                                    caseDetails: caseDetails,
                                    dischargeDate: dischargeDate
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "jsx-72c8f128dbbb05ec" + " " + "d-flex",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("table", {
                                        className: "jsx-72c8f128dbbb05ec" + " " + "fs-7",
                                        children: [
                                            caseDetails && caseDetails.purpose && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("tr", {
                                                    className: "jsx-72c8f128dbbb05ec",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                        className: "jsx-72c8f128dbbb05ec" + " " + "py-1",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "jsx-72c8f128dbbb05ec",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "jsx-72c8f128dbbb05ec" + " " + "fw-bold text-decoration-underline py-3 fs-6",
                                                                    children: "Purpose"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    style: {
                                                                        whiteSpace: "pre-line"
                                                                    },
                                                                    className: "jsx-72c8f128dbbb05ec" + " " + "pl-md-5",
                                                                    children: caseDetails && caseDetails.purpose
                                                                })
                                                            ]
                                                        })
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("tr", {
                                                className: "jsx-72c8f128dbbb05ec",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                    className: "jsx-72c8f128dbbb05ec" + " " + "py-1 align-top",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "jsx-72c8f128dbbb05ec",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "jsx-72c8f128dbbb05ec" + " " + "fw-bold text-decoration-underline py-1 fs-6",
                                                                children: "Medical Details"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "jsx-72c8f128dbbb05ec" + " " + "pl-md-5",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: "jsx-72c8f128dbbb05ec" + " " + "row",
                                                                    children: [
                                                                        caseDetailsJson["cc"] && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                            className: "jsx-72c8f128dbbb05ec" + " " + "col col-6",
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                className: "jsx-72c8f128dbbb05ec" + " " + "d-flex my-1",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                        className: "jsx-72c8f128dbbb05ec" + " " + " fw-bold",
                                                                                        children: "Chief Complaints :\xa0"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                        style: {
                                                                                            whiteSpace: "pre-line"
                                                                                        },
                                                                                        className: "jsx-72c8f128dbbb05ec",
                                                                                        children: caseDetailsJson["cc"]
                                                                                    })
                                                                                ]
                                                                            })
                                                                        }),
                                                                        caseDetailsJson["hpi"] && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                            className: "jsx-72c8f128dbbb05ec" + " " + "col col-6",
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                className: "jsx-72c8f128dbbb05ec" + " " + "d-flex my-1",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                        className: "jsx-72c8f128dbbb05ec" + " " + "fw-bold",
                                                                                        children: "History of Present Illness :\xa0"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                        style: {
                                                                                            whiteSpace: "pre-line"
                                                                                        },
                                                                                        className: "jsx-72c8f128dbbb05ec",
                                                                                        children: caseDetailsJson["hpi"]
                                                                                    })
                                                                                ]
                                                                            })
                                                                        }),
                                                                        caseDetailsJson["personal_history"] && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                            className: "jsx-72c8f128dbbb05ec" + " " + "col col-6",
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                className: "jsx-72c8f128dbbb05ec" + " " + "d-flex my-1",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                        className: "jsx-72c8f128dbbb05ec" + " " + " fw-bold",
                                                                                        children: "Personal History :\xa0"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                        style: {
                                                                                            whiteSpace: "pre-line"
                                                                                        },
                                                                                        className: "jsx-72c8f128dbbb05ec",
                                                                                        children: caseDetailsJson["personal_history"]
                                                                                    })
                                                                                ]
                                                                            })
                                                                        }),
                                                                        caseDetailsJson["birth_history"] && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                            className: "jsx-72c8f128dbbb05ec" + " " + "col col-6",
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                className: "jsx-72c8f128dbbb05ec" + " " + "d-flex my-1",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                        className: "jsx-72c8f128dbbb05ec" + " " + " fw-bold",
                                                                                        children: "Birth/Family History :\xa0"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                        style: {
                                                                                            whiteSpace: "pre-line"
                                                                                        },
                                                                                        className: "jsx-72c8f128dbbb05ec",
                                                                                        children: caseDetailsJson["birth_history"]
                                                                                    })
                                                                                ]
                                                                            })
                                                                        }),
                                                                        caseDetailsJson["drug_allergy"] && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                            className: "jsx-72c8f128dbbb05ec" + " " + "col col-6",
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                className: "jsx-72c8f128dbbb05ec" + " " + "d-flex my-1",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                        className: "jsx-72c8f128dbbb05ec" + " " + " fw-bold",
                                                                                        children: "Drug Allergy :\xa0"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                        style: {
                                                                                            whiteSpace: "pre-line"
                                                                                        },
                                                                                        className: "jsx-72c8f128dbbb05ec",
                                                                                        children: caseDetailsJson["drug_allergy"]
                                                                                    })
                                                                                ]
                                                                            })
                                                                        }),
                                                                        caseDetailsJson["treatment_history"] && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                            className: "jsx-72c8f128dbbb05ec" + " " + "col col-6",
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                className: "jsx-72c8f128dbbb05ec" + " " + "d-flex my-1",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                        className: "jsx-72c8f128dbbb05ec" + " " + " fw-bold",
                                                                                        children: "Treatment History :\xa0"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                        style: {
                                                                                            whiteSpace: "pre-line"
                                                                                        },
                                                                                        className: "jsx-72c8f128dbbb05ec",
                                                                                        children: caseDetailsJson["treatment_history"]
                                                                                    })
                                                                                ]
                                                                            })
                                                                        }),
                                                                        events && events.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                            className: "jsx-72c8f128dbbb05ec" + " " + "col col-6 ",
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PatientPreconditionsView/* PatientPreconditionsView */.O, {
                                                                                preconditions: events,
                                                                                updatePreconditions: null,
                                                                                isEditable: false,
                                                                                entityQr: null,
                                                                                category: null
                                                                            })
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        ]
                                                    })
                                                })
                                            }),
                                            caseDetails && caseDetails.diagnosis && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("tr", {
                                                    className: "jsx-72c8f128dbbb05ec",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                        className: "jsx-72c8f128dbbb05ec" + " " + "py-1 align-top",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "jsx-72c8f128dbbb05ec",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "jsx-72c8f128dbbb05ec" + " " + "fw-bold text-decoration-underline py-1 fs-6",
                                                                    children: "Diagnosis"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    style: {
                                                                        whiteSpace: "pre-line"
                                                                    },
                                                                    className: "jsx-72c8f128dbbb05ec" + " " + "pl-md-5",
                                                                    children: caseDetails && caseDetails.diagnosis
                                                                })
                                                            ]
                                                        })
                                                    })
                                                })
                                            }),
                                            records && records.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("tr", {
                                                    className: "jsx-72c8f128dbbb05ec",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                        className: "jsx-72c8f128dbbb05ec" + " " + "py-1 align-top",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "jsx-72c8f128dbbb05ec",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "jsx-72c8f128dbbb05ec" + " " + "fw-bold text-decoration-underline py-1 fs-6",
                                                                    children: "Investigations / Services"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "jsx-72c8f128dbbb05ec" + " " + "pl-md-5",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("table", {
                                                                        className: "jsx-72c8f128dbbb05ec",
                                                                        children: records.map(function(entry) {
                                                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                                                className: "jsx-72c8f128dbbb05ec",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                                        className: "jsx-72c8f128dbbb05ec" + " " + "text-nowrap align-top",
                                                                                        children: entry && entry.recordType
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                                        className: "jsx-72c8f128dbbb05ec" + " " + "pl-4 align-top",
                                                                                        children: entry.description && entry.description != "null" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                            dangerouslySetInnerHTML: {
                                                                                                __html: entry.description
                                                                                            },
                                                                                            className: "jsx-72c8f128dbbb05ec"
                                                                                        })
                                                                                    })
                                                                                ]
                                                                            }, entry.recordType);
                                                                        })
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("tr", {
                                                className: "jsx-72c8f128dbbb05ec",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                    className: "jsx-72c8f128dbbb05ec" + " " + "py-1 align-top",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "jsx-72c8f128dbbb05ec",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "jsx-72c8f128dbbb05ec" + " " + "fw-bold text-decoration-underline py-1 fs-6",
                                                                children: "Procedures / Surgeries"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "jsx-72c8f128dbbb05ec" + " " + "pl-md-5",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("table", {
                                                                    className: "jsx-72c8f128dbbb05ec",
                                                                    children: auditEntries.filter(function(e) {
                                                                        return e.type == "PROCEDURE";
                                                                    }).map(function(entry) {
                                                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                                            className: "jsx-72c8f128dbbb05ec",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                                    className: "jsx-72c8f128dbbb05ec" + " " + "text-nowrap align-top",
                                                                                    children: entry.procedureName
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                                    className: "jsx-72c8f128dbbb05ec" + " " + "pl-4 align-top",
                                                                                    children: entry.procedureDetails && entry.description != "null" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                        dangerouslySetInnerHTML: {
                                                                                            __html: entry.procedureDetails
                                                                                        },
                                                                                        className: "jsx-72c8f128dbbb05ec"
                                                                                    })
                                                                                })
                                                                            ]
                                                                        }, entry.procedureName);
                                                                    })
                                                                })
                                                            })
                                                        ]
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("tr", {
                                                className: "jsx-72c8f128dbbb05ec",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                    className: "jsx-72c8f128dbbb05ec" + " " + "py-1 align-top",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "jsx-72c8f128dbbb05ec",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "jsx-72c8f128dbbb05ec" + " " + "fw-bold text-decoration-underline py-1 fs-6",
                                                                children: "Treatment Details"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "jsx-72c8f128dbbb05ec" + " " + "pl-md-5",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("table", {
                                                                    className: "jsx-72c8f128dbbb05ec",
                                                                    children: auditEntries.filter(function(e) {
                                                                        return e.type == "VISIT";
                                                                    }).map(function(entry) {
                                                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                                            className: "jsx-72c8f128dbbb05ec",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                                    className: "jsx-72c8f128dbbb05ec" + " " + "text-nowrap align-top",
                                                                                    children: entry.assignedDr ? entry.assignedDr + " (" + entry.createdAt + ")" : entry.createdAt
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                                    className: "jsx-72c8f128dbbb05ec" + " " + "pl-4 align-top",
                                                                                    children: entry.notes && entry.notes != "null" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                        dangerouslySetInnerHTML: {
                                                                                            __html: entry.notes
                                                                                        },
                                                                                        className: "jsx-72c8f128dbbb05ec"
                                                                                    })
                                                                                })
                                                                            ]
                                                                        }, entry.procedureName);
                                                                    })
                                                                })
                                                            })
                                                        ]
                                                    })
                                                })
                                            }),
                                            auditEntries.map(function(entry) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                    children: entry.type == "DISCHARGE_SUMMARY" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("tr", {
                                                                className: "jsx-72c8f128dbbb05ec",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                    className: "jsx-72c8f128dbbb05ec" + " " + "py-1 align-top",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: "jsx-72c8f128dbbb05ec",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                className: "jsx-72c8f128dbbb05ec" + " " + "fw-bold text-decoration-underline py-1 fs-6",
                                                                                children: "Discharge Remarks"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                className: "jsx-72c8f128dbbb05ec" + " " + "pl-md-5",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                        dangerouslySetInnerHTML: {
                                                                                            __html: entry.notes
                                                                                        },
                                                                                        className: "jsx-72c8f128dbbb05ec"
                                                                                    }),
                                                                                    entry.presId && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                        className: "jsx-72c8f128dbbb05ec" + " " + "multi-pager",
                                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IpdPrescriptionWritingView/* IpdPrescriptionWritingView */.X, {
                                                                                            entityQr: caseDetails.entityQr,
                                                                                            isEditable: false,
                                                                                            qrCode: assignedDrQr,
                                                                                            id: entry.presId
                                                                                        })
                                                                                    }),
                                                                                    entry.extraDetails && JSON.parse(entry.extraDetails).follow_up_date && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                        className: "jsx-72c8f128dbbb05ec" + " " + "my-1",
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                                className: "jsx-72c8f128dbbb05ec" + " " + "fw-bold",
                                                                                                children: "Follow-up Date :"
                                                                                            }),
                                                                                            " ",
                                                                                            new Date(JSON.parse(entry.extraDetails).follow_up_date).toLocaleDateString("en-GB")
                                                                                        ]
                                                                                    })
                                                                                ]
                                                                            })
                                                                        ]
                                                                    })
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("tr", {
                                                                className: "jsx-72c8f128dbbb05ec",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("td", {
                                                                    className: "jsx-72c8f128dbbb05ec" + " " + "py-2 align-top",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: "jsx-72c8f128dbbb05ec" + " " + "d-flex justify-content-between",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                    className: "jsx-72c8f128dbbb05ec",
                                                                                    children: "Patient Signature:"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                    className: "jsx-72c8f128dbbb05ec",
                                                                                    children: "RMO Signature:"
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: "jsx-72c8f128dbbb05ec" + " " + "d-flex justify-content-between mt-5",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                    className: "jsx-72c8f128dbbb05ec",
                                                                                    children: [
                                                                                        "Consultants:",
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {
                                                                                            className: "jsx-72c8f128dbbb05ec"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {
                                                                                            className: "jsx-72c8f128dbbb05ec"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {
                                                                                            className: "jsx-72c8f128dbbb05ec"
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                    className: "jsx-72c8f128dbbb05ec" + " " + "mr-4",
                                                                                    children: [
                                                                                        "Attendants:",
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {
                                                                                            className: "jsx-72c8f128dbbb05ec"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {
                                                                                            className: "jsx-72c8f128dbbb05ec"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {
                                                                                            className: "jsx-72c8f128dbbb05ec"
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        ]
                                                    })
                                                });
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "jsx-72c8f128dbbb05ec",
                            children: [
                                auditEntries.filter(function(e) {
                                    return e.type == "SERVICE";
                                }).map(function(entry) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                        children: entry && /*#__PURE__*/ (0,jsx_runtime.jsx)(LabRecordsPrintView, {
                                            uhid: caseDetails && caseDetails.uhid,
                                            entityQr: caseDetails && caseDetails.entityQr,
                                            printHeader: false,
                                            visitId: entry.id,
                                            stateTracker: null,
                                            referringDr: caseDetails && caseDetails.assignedDr
                                        })
                                    });
                                }),
                                records.map(function(entry) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                        children: entry && entry.data && JSON.parse(entry.data).key && !isPdf(JSON.parse(entry.data).key) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "jsx-72c8f128dbbb05ec" + " " + "printElements border",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "jsx-72c8f128dbbb05ec" + " " + "font-weight-bold text-center pt-2",
                                                    children: [
                                                        "Record - ",
                                                        entry.recordType
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    alt: "case-file-view-icon",
                                                    src: "/api/s3/download/?file=" + JSON.parse(entry.data).key,
                                                    width: "100%",
                                                    className: "jsx-72c8f128dbbb05ec"
                                                })
                                            ]
                                        })
                                    });
                                })
                            ]
                        }),
                        (0,jsx_runtime.jsx)((style_default()), {
                            id: "72c8f128dbbb05ec",
                            children: "@page{margin:40px 0 40px 0!important}"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "d-flex justify-content-end",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "text-warning align-self-center",
                            children: "* Please scroll & print the uploaded documents seperately"
                        }),
                        "\xa0\xa0",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "align-self-center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((lib_default()), {
                                trigger: function() {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        className: "btn btn-outline-primary",
                                        children: "\uD83D\uDDA8 Case Summary"
                                    });
                                },
                                content: function() {
                                    return componentRef.current;
                                }
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: records.map(function(entry) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: entry && entry.data && JSON.parse(entry.data).key && isPdf(JSON.parse(entry.data).key) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "printElements",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "font-weight-bold text-center pt-2",
                                        children: [
                                            "Record - ",
                                            entry.recordType
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                                        src: "/api/s3/download/?file=" + JSON.parse(entry.data).key,
                                        width: "100%",
                                        height: "800px"
                                    })
                                ]
                            })
                        });
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: props.uploads.map(function(entry) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                isPdf(entry.key) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "printElements",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "font-weight-bold text-center pt-4",
                                            children: [
                                                "Uploaded - ",
                                                entry.name
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                                            src: "/api/s3/download/?file=" + entry.key,
                                            width: "100%",
                                            height: "800px"
                                        })
                                    ]
                                }),
                                !isPdf(entry.key) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "printElements border",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "font-weight-bold text-center pt-4",
                                            children: [
                                                "Uploaded - ",
                                                entry.name
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            alt: "case-file-view-icon",
                                            src: "/api/s3/download/?file=" + entry.key,
                                            width: "100%"
                                        })
                                    ]
                                })
                            ]
                        });
                    })
                })
            ]
        });
    };
    var isPdf = function isPdf(fileName) {
        var fileArr = fileName.split(".");
        return fileArr[fileArr.length - 1] == "pdf";
    };
    var ref = (0,react.useState)([]), records = ref[0], setRecords = ref[1];
    var ref1 = (0,react.useState)(), caseDetails = ref1[0], setCaseDetails = ref1[1];
    var ref2 = (0,react.useState)({}), caseDetailsJson = ref2[0], setCaseDetailsJson = ref2[1];
    var ref3 = (0,react.useState)([]), auditEntries = ref3[0], setAuditEntries = ref3[1];
    var ref4 = (0,react.useState)([]), events = ref4[0], setEvents = ref4[1];
    var ref5 = (0,react.useState)(), assignedDrQr = ref5[0], setAssignedDrQr = ref5[1];
    var ref6 = (0,react.useState)(), dischargeDate = ref6[0], setDischargeDate = ref6[1];
    var componentRef = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        if (props.caseId) {
            fetchCase();
        }
    }, [
        props.caseId,
        props.stateTracker
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: getDischargeSummaryView()
    });
};

// EXTERNAL MODULE: ./node_modules/react-cookie/es6/useCookies.js + 6 modules
var useCookies = __webpack_require__(70461);
// EXTERNAL MODULE: ./node_modules/react-datepicker/dist/react-datepicker.min.js
var react_datepicker_min = __webpack_require__(9198);
var react_datepicker_min_default = /*#__PURE__*/__webpack_require__.n(react_datepicker_min);
// EXTERNAL MODULE: ./components/permissions.ts
var permissions = __webpack_require__(13677);
;// CONCATENATED MODULE: ./components/ipd/subCategories/discharge/AddDischargeDetailsView.tsx

















var AddDischargeDetailsView = function(props) {
    var fetchDischargeDetails = function fetchDischargeDetails(caseId, entityQr) {
        axios_default().get("/api/backend/ipd/case/audit/fetch/all/" + entityQr + "/" + caseId).then(function(resp) {
            console.log(JSON.stringify(resp.data));
            var dischargeEntry = resp.data.filter(function(entry) {
                return entry.type == "DISCHARGE_SUMMARY";
            });
            if (dischargeEntry && dischargeEntry.length > 0) {
                var dischargeItem = dischargeEntry[0];
                setDischargeItem(dischargeItem);
                setNotes(dischargeItem.notes);
                setPrescId(dischargeItem.presId);
                if (dischargeItem.patientStatus) setPatientStatus(dischargeItem.patientStatus);
                if (dischargeItem.extraDetails) {
                    setApprovers(JSON.parse(dischargeItem.extraDetails));
                    if (JSON.parse(dischargeItem.extraDetails).follow_up_date) setFollowUpDate(new Date(JSON.parse(dischargeItem.extraDetails).follow_up_date));
                }
            }
        }).catch(function(err) {
            console.error(err);
            if (err.response && err.response.status && err.response.status === 403) {
                (0,utils/* handleLogout */.hY)();
            }
        });
    };
    var getModalForDischarge = function getModalForDischarge() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* default */.Z, {
            show: showDischargeModal,
            onHide: handleCloseDischargeModal,
            backdrop: "static",
            className: "modal-xl",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default.Header */.Z.Header, {
                    closeButton: true
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* default.Body */.Z.Body, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default */.Z, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default.Header */.Z.Header, {
                                    className: "text-info fw-bold",
                                    children: "Preview"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default.Body */.Z.Body, {
                                    children: props.caseDetails && /*#__PURE__*/ (0,jsx_runtime.jsx)(DischargeSummary/* DischargeSummary */.T, {
                                        trackId: props.caseDetails.trackId,
                                        isFromLink: false,
                                        doctors: props.doctors,
                                        isPreview: true
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "my-2",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    className: "btn btn-info text-white btn-sm",
                                    onClick: handleCloseDischargeModal,
                                    children: "Back"
                                }),
                                "\xa0",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    className: "btn btn-success text-white btn-sm",
                                    onClick: handleDischargePatient,
                                    children: "Confirm"
                                })
                            ]
                        })
                    ]
                })
            ]
        });
    };
    var ref = (0,react.useState)(null), successMessage = ref[0], setSuccessMessage = ref[1];
    var ref1 = (0,react.useState)(false), loading = ref1[0], setLoading = ref1[1];
    var ref2 = (0,react.useState)(null), errorMessage = ref2[0], setErrorMessage = ref2[1];
    var ref3 = (0,react.useState)(null), dischargeItem = ref3[0], setDischargeItem = ref3[1];
    var ref4 = (0,react.useState)("DISCHARGE"), patientStatus = ref4[0], setPatientStatus = ref4[1];
    var ref5 = (0,react.useState)(new Date(Date.now() + 3)), followUpDate = ref5[0], setFollowUpDate = ref5[1];
    var ref6 = (0,react.useState)({}), approvers = ref6[0], setApprovers = ref6[1];
    var ref7 = (0,react.useState)(null), qrCode = ref7[0], setQrCode = ref7[1];
    var ref8 = (0,react.useState)(null), prCategory = ref8[0], setPrCategory = ref8[1];
    var ref9 = (0,react.useState)(null), prescId = ref9[0], setPrescId = ref9[1];
    var ref10 = (0,react.useState)([]), lineItems = ref10[0], setLineItems = ref10[1];
    var ref11 = (0,react.useState)(null), notes = ref11[0], setNotes = ref11[1];
    var ref12 = (0,_sliced_to_array/* default */.Z)((0,useCookies/* default */.Z)([
        "qme"
    ]), 1), cookie = ref12[0];
    (0,react.useEffect)(function() {
        fetchDischargeDetails(props.id, props.cookieEntityQr);
    }, [
        props.id
    ]);
    var ref13 = (0,react.useState)(false), showDischargeModal = ref13[0], setShowDischargeModal = ref13[1];
    var handleCloseDischargeModal = function() {
        return setShowDischargeModal(false);
    };
    var handleShowDischargeModal = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            handleAddDischargeRemarks(false)
                        ];
                    case 1:
                        _state.sent();
                        setShowDischargeModal(true);
                        return [
                            2
                        ];
                }
            });
        });
        return function handleShowDischargeModal() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        if (props.caseDetails && props.doctors && props.doctors.filter(function(dr) {
            return dr.id == props.caseDetails.assignedDrId;
        }).length > 0) {
            setQrCode(props.doctors.filter(function(dr) {
                return dr.id == props.caseDetails.assignedDrId;
            })[0]["qrCode"]);
            setPrCategory(props.doctors.filter(function(dr) {
                return dr.id == props.caseDetails.assignedDrId;
            })[0]["category"]);
        }
    }, [
        props.caseDetails
    ]);
    function saveDischargeData(callPostAction) {
        return _saveDischargeData.apply(this, arguments);
    }
    function _saveDischargeData() {
        _saveDischargeData = (0,_async_to_generator/* default */.Z)(function(callPostAction) {
            var url, _tmp;
            return (0,tslib_es6.__generator)(this, function(_state) {
                if (dischargeItem && dischargeItem.id) {
                    url = "/api/backend/ipd/case/audit/update/" + dischargeItem.id;
                } else {
                    url = "/api/backend/ipd/case/audit/create";
                }
                _tmp = {};
                axios_default().post(url, (_tmp.entityQr = props.cookieEntityQr, _tmp.caseId = props.id, _tmp.notes = notes, _tmp.lineItems = lineItems, _tmp.clientQr = qrCode, _tmp.prCategory = prCategory, _tmp.patientStatus = patientStatus, _tmp.extraDetails = JSON.stringify((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, approvers), {
                    follow_up_date: followUpDate
                })), _tmp.type = "DISCHARGE_SUMMARY", _tmp)).then(function(resp) {
                    console.log(resp.data);
                    fetchDischargeDetails(props.id, props.cookieEntityQr);
                    if (callPostAction) {
                        props.postAction();
                    }
                }).catch(function(err) {
                    console.error(err);
                    if (err.response && err.response.status && err.response.status === 403) {
                        (0,utils/* handleLogout */.hY)();
                    }
                    setErrorMessage("Error while creating the Discharge Entry");
                });
                return [
                    2
                ];
            });
        });
        return _saveDischargeData.apply(this, arguments);
    }
    var handleAddDischargeRemarks = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(callPostAction) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            saveDischargeData(callPostAction)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function handleAddDischargeRemarks(callPostAction) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleDischargePatient = function() {
        axios_default().post("/api/backend/ipd/case/update/status/" + props.id + "/DISCHARGED", null).then(function(resp) {
            console.log(resp.data);
            props.postAction();
        }).catch(function(err) {
            console.error(err);
            if (err.response && err.response.status && err.response.status === 403) {
                (0,utils/* handleLogout */.hY)();
            }
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "pt-2",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Label */.Z.Label, {
                        className: "text-info fs-7",
                        children: "Discharge Type"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("select", {
                        className: "form-select form-select-sm",
                        value: patientStatus,
                        onChange: function(e) {
                            return setPatientStatus(e.target.value);
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                value: "DISCHARGE",
                                children: "Patient Discharge"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                value: "DEATH",
                                children: "Death"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                value: "LAMA",
                                children: "Leave against medical advise"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                value: "DISCHARGE ON REQUEST",
                                children: "Discharge on request"
                            })
                        ]
                    }),
                    qrCode && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Accordion/* default */.Z, {
                            className: "my-2",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Accordion/* default.Item */.Z.Item, {
                                eventKey: "0",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Accordion/* default.Header */.Z.Header, {
                                        className: "accordian-base-colour",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "text-info",
                                            children: " Discharge Prescription"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Accordion/* default.Body */.Z.Body, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IpdPrescriptionWritingView/* IpdPrescriptionWritingView */.X, {
                                            entityQr: props.cookieEntityQr,
                                            isEditable: true,
                                            qrCode: qrCode,
                                            id: prescId,
                                            setLineItems: setLineItems
                                        })
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Label */.Z.Label, {
                        className: "text-info fs-7",
                        children: "Discharge Remarks"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RichEditor/* RichEditor */.E, {
                        data: notes,
                        setData: setNotes,
                        height: 500
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "d-flex gap-2 my-2 justify-content-between",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Label */.Z.Label, {
                                className: "text-info fs-7 text-nowrap align-self-center",
                                children: "Follow-up Date"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((react_datepicker_min_default()), {
                                className: "form-control form-control-sm",
                                selected: followUpDate,
                                onChange: function(date) {
                                    return setFollowUpDate(date);
                                },
                                dateFormat: "dd/MM/yyyy"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "d-flex gap-2 my-2 justify-content-between",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "d-flex gap-2 flex-fill",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Label */.Z.Label, {
                                        className: "text-info fs-7 text-nowrap align-self-center",
                                        children: "Clinical Approver"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                        className: "form-control form-control-sm",
                                        placeholder: "Name of the approver",
                                        disabled: !(0,permissions/* hasPermissions */.qX)(cookie.qme, permissions/* IPD_DISCHARGE */.Sm),
                                        onChange: function(e) {
                                            return setApprovers((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, approvers), {
                                                clinical_approver: e.target.value
                                            }));
                                        },
                                        value: approvers["clinical_approver"]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "d-flex gap-2 flex-fill",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Label */.Z.Label, {
                                        className: "text-info fs-7 text-nowrap align-self-center",
                                        children: "Accounts Approver"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                        className: "form-control form-control-sm",
                                        placeholder: "Name of the approver",
                                        disabled: !(0,permissions/* hasPermissions */.qX)(cookie.qme, permissions/* IPD_DISCHARGE */.Sm),
                                        onChange: function(e) {
                                            return setApprovers((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, approvers), {
                                                accounts_approver: e.target.value
                                            }));
                                        },
                                        value: approvers["accounts_approver"]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            getModalForDischarge(),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "pt-4",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        className: "btn btn-info text-white btn-sm",
                        onClick: function(e) {
                            return handleAddDischargeRemarks(true);
                        },
                        children: "Save Details"
                    }),
                    "\xa0\xa0",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        className: "btn btn-success text-white btn-sm",
                        onClick: handleShowDischargeModal,
                        disabled: !(approvers["accounts_approver"] && approvers["clinical_approver"] && (0,permissions/* hasPermissions */.qX)(cookie.qme, permissions/* IPD_DISCHARGE */.Sm)),
                        children: "Discharge Patient"
                    })
                ]
            }),
            !(0,permissions/* hasPermissions */.qX)(cookie.qme, permissions/* IPD_DISCHARGE */.Sm) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "fs-7 text-warning",
                children: "You don't have the permissions to discharge a Patient. Please contact your admin."
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/ipd/consentForms/case/ConsentFormPrintView.tsx







var ConsentFormPrintView = function(props) {
    var getItemForm = function getItemForm() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                dangerouslySetInnerHTML: {
                    __html: content
                }
            })
        });
    };
    var ref = (0,react.useState)(null), content = ref[0], setContent = ref[1];
    var componentRef = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        axios_default().get("/api/backend/form/template/fetch/" + props.id + "/" + props.caseDetails.uhid).then(function(resp) {
            console.log(JSON.stringify(resp.data));
            if (resp.data) {
                setContent(resp.data.content);
            }
        }).catch(function(err) {
            console.error(err);
            if (err.response && err.response.status && err.response.status === 403) {
                (0,utils/* handleLogout */.hY)();
            }
        });
    }, [
        props.id
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                ref: componentRef,
                className: "m-4",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CaseHeaderView/* CaseHeaderView */.Q, {
                        caseDetails: props.caseDetails,
                        dischargeDate: props.dischargeDate
                    }),
                    getItemForm()
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mx-4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((lib_default()), {
                    trigger: function() {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            className: "btn btn-outline-secondary text-secondary bg-white btn-sm rounded-form",
                            children: "\uD83D\uDDA8 Print Form"
                        });
                    },
                    content: function() {
                        return componentRef.current;
                    }
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/ipd/consentForms/case/CaseConsentFormsView.tsx







var CaseConsentFormsView = function(props) {
    var fetchItems = function fetchItems() {
        axios_default().get("/api/backend/form/template/fetch/all/" + props.cookieEntityQr).then(function(resp) {
            console.log(JSON.stringify(resp.data));
            if (resp.data) {
                setItems(resp.data);
            }
        }).catch(function(err) {
            console.error(err);
            if (err.response && err.response.status && err.response.status === 403) {
                (0,utils/* handleLogout */.hY)();
            }
        });
    };
    var getModalForItemPreview = function getModalForItemPreview() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* default */.Z, {
            show: showItemPreviewModal,
            onHide: handleCloseItemPreviewModal,
            backdrop: "static",
            className: "modal-xl",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default.Header */.Z.Header, {
                    closeButton: true
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default.Body */.Z.Body, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsentFormPrintView, {
                        id: itemId,
                        entityQr: props.cookieEntityQr,
                        caseDetails: props.caseDetails,
                        dischargeDate: props.dischargeDate
                    })
                })
            ]
        });
    };
    var getItemsTable = function getItemsTable() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "overflow-scroll",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* DatatableWrapper */.sm, {
                body: items,
                headers: ITEMS_HEADERS,
                paginationOptionsProps: {
                    initialState: {
                        rowsPerPage: 30,
                        options: [
                            30,
                            50,
                            100
                        ]
                    }
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                        className: "mb-4 p-2",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                xs: 12,
                                lg: 4,
                                className: "d-flex flex-col justify-content-end align-items-end",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Filter */.wn, {})
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                xs: 12,
                                sm: 6,
                                lg: 4,
                                className: "d-flex flex-col justify-content-lg-center align-items-center justify-content-sm-start mb-2 mb-sm-0",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* PaginationOptions */.c_, {})
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                xs: 12,
                                sm: 6,
                                lg: 4,
                                className: "d-flex flex-col justify-content-end align-items-end",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Pagination */.tl, {})
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Table/* default */.Z, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* TableHeader */.xD, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* TableBody */.RM, {})
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                        className: "mt-4 p-2",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                            xs: 12,
                            sm: 12,
                            lg: 12,
                            className: "d-flex flex-col justify-content-end align-items-end",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Pagination */.tl, {})
                        })
                    })
                ]
            })
        });
    };
    var ref = (0,react.useState)([]), items = ref[0], setItems = ref[1];
    (0,react.useEffect)(function() {
        fetchItems();
    }, [
        props.cookieEntityQr
    ]);
    var ref1 = (0,react.useState)(), itemId = ref1[0], setItemId = ref1[1];
    var ref2 = (0,react.useState)(false), showItemPreviewModal = ref2[0], setShowItemPreviewModal = ref2[1];
    var handleCloseItemPreviewModal = function() {
        return setShowItemPreviewModal(false);
    };
    var handleShowItemPreviewModal = function(itemId) {
        setItemId(itemId);
        setShowItemPreviewModal(true);
    };
    var ITEMS_HEADERS = [
        {
            prop: "name",
            title: "Name",
            isFilterable: true,
            isSortable: true
        },
        {
            prop: "button",
            cell: function(row) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                        href: "#/",
                        className: "edit text-primary",
                        onClick: function() {
                            return handleShowItemPreviewModal(row.id);
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                alt: "session-management",
                                src: "/emr/preview_icon.png",
                                width: "30",
                                height: "30"
                            }),
                            "\xa0\xa0Preview"
                        ]
                    })
                });
            }
        }
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "row my-5",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "col",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "card p-2 shadow-sm",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "d-flex justify-content-between py-2 pr-1",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                className: "text-primary pl-1",
                                children: "Consent Forms"
                            })
                        }),
                        getItemsTable(),
                        getModalForItemPreview()
                    ]
                })
            })
        })
    });
};

;// CONCATENATED MODULE: ./components/ipd/IpdUploadView.tsx









var IpdUploadView = /*#__PURE__*/ (0,react.forwardRef)(function(props, ref) {
    var getItemsTable = function getItemsTable() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "overflow-scroll",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* DatatableWrapper */.sm, {
                body: uploads,
                headers: ITEMS_HEADERS,
                paginationOptionsProps: {
                    initialState: {
                        rowsPerPage: 30,
                        options: [
                            30,
                            50,
                            100
                        ]
                    }
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                        className: "",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                xs: 12,
                                lg: 4,
                                className: "d-flex flex-col justify-content-end align-items-end"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                xs: 12,
                                sm: 6,
                                lg: 4,
                                className: "d-flex flex-col justify-content-lg-center align-items-center justify-content-sm-start mb-2 mb-sm-0"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                xs: 12,
                                sm: 6,
                                lg: 4,
                                className: "d-flex flex-col justify-content-end align-items-end"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Table/* default */.Z, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* TableHeader */.xD, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* TableBody */.RM, {})
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                        className: "mt-4",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                            xs: 12,
                            sm: 12,
                            lg: 12,
                            className: "d-flex flex-col justify-content-end align-items-end"
                        })
                    })
                ]
            })
        });
    };
    var ref1 = (0,react.useState)([]), uploads = ref1[0], setUploads = ref1[1];
    var ref2 = (0,react.useState)(), name = ref2[0], setName = ref2[1];
    var ref3 = (0,react.useState)(false), loading = ref3[0], setLoading = ref3[1];
    var ref4 = (0,react.useState)(null), errorMessage = ref4[0], setErrorMessage = ref4[1];
    var ref5 = (0,react.useState)(), file = ref5[0], setFile = ref5[1];
    var componentRef = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        if (props.caseDetails) {
            setUploads(props.caseDetails.uploads ? JSON.parse(props.caseDetails.uploads) : []);
        }
    }, [
        props.caseDetails
    ]);
    var handleChange = function(event) {
        setErrorMessage(null);
        if (event.target.files && event.target.files[0]) {
            var selectedFile = event.target.files[0];
            if (selectedFile.size > 6000000) {
                setErrorMessage("File size should be less than 5 MB");
            } else {
                setFile(selectedFile);
            }
        }
    };
    var uploadFile = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var key, data, _tmp, url, ref, newData, _tmp1;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        key = props.caseDetails.caseId + "_" + file.name;
                        _tmp = {};
                        return [
                            4,
                            axios_default().post("/api/s3/upload", (_tmp.name = key, _tmp.type = file.type, _tmp))
                        ];
                    case 1:
                        data = _state.sent().data;
                        console.log(data);
                        url = data.url;
                        _tmp1 = {};
                        return [
                            4,
                            axios_default().put(url, file, (_tmp1.headers = {
                                "Content-type": file.type,
                                "Access-Control-Allow-Origin": "*"
                            }, _tmp1))
                        ];
                    case 2:
                        ref = _state.sent(), newData = ref.data;
                        console.log(newData);
                        return [
                            2,
                            key
                        ];
                }
            });
        });
        return function uploadFile() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleUpdate = function(e) {
        e.preventDefault();
        setErrorMessage(null);
        setLoading(true);
        if (!file) {
            setErrorMessage("Please select a file to upload");
        }
        uploadFile().then(function(resp) {
            console.log(resp);
            axios_default().post("/api/backend/ipd/case/update/uploads/" + props.caseDetails.id, {
                upload: JSON.stringify((0,_to_consumable_array/* default */.Z)(uploads).concat([
                    {
                        name: name,
                        key: resp
                    }
                ]))
            }).then(function(resp) {
                console.log(resp.data);
                props.fetch();
            }).catch(function(err) {
                setErrorMessage("Error while creating the record. Please verify the record Id");
                console.error(err);
                if (err.response && err.response.status && err.response.status === 403) {
                    (0,utils/* handleLogout */.hY)();
                }
            }).finally(function() {
                return setLoading(false);
            });
        }).catch(function(err) {
            console.error(err);
            if (err.response && err.response.status && err.response.status === 403) {
                (0,utils/* handleLogout */.hY)();
            }
            setErrorMessage("Error while uploading the file");
        }).finally(function() {
            return setLoading(false);
        });
    };
    var ITEMS_HEADERS = [
        {
            prop: "name",
            title: "Name",
            isFilterable: true,
            isSortable: true
        },
        {
            prop: "button",
            cell: function(row) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        target: "_blank",
                        rel: "noreferrer",
                        href: "/api/s3/download/?file=" + row.key,
                        className: "text-success font-weight-bold",
                        children: " ↓"
                    })
                });
            }
        }
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "row",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "col col-12",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                    className: "text-primary",
                                    children: "Uploads"
                                }),
                                getItemsTable()
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col col-12",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "my-2 d-flex gap-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                        className: "align-self-center text-info text-nowrap",
                                        children: "File Name:"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                        type: "text",
                                        className: "form-control form-control-sm",
                                        onChange: function(e) {
                                            return setName(e.target.value);
                                        }
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col col-12",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "my-2 d-flex gap-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                        className: "align-self-center text-info",
                                        children: "File:"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                        type: "file",
                                        ref: componentRef,
                                        className: "form-control form-select-sm",
                                        accept: ".doc,.docx,.HEIC,.HEIC,.HEVC,image/*,application/pdf",
                                        onChange: handleChange
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "my-4",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                            className: "btn btn-info text-white btn-sm",
                            onClick: function(e) {
                                return handleUpdate(e);
                            },
                            children: [
                                loading && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "text-center",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "spinner-border",
                                        role: "status"
                                    })
                                }),
                                !loading && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                    children: "Add Report"
                                })
                            ]
                        }),
                        errorMessage && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "text-danger fs-6",
                            children: [
                                "*",
                                errorMessage
                            ]
                        })
                    ]
                })
            ]
        })
    });
});
IpdUploadView.displayName = "IpdUploadView";

;// CONCATENATED MODULE: ./components/ipd/CaseView.tsx





















var CaseView = function(props) {
    var fetchCase = function fetchCase() {
        axios_default().get("/api/backend/ipd/case/fetch/" + props.cookieEntityQr + "/" + props.case.caseId).then(function(resp) {
            console.log(JSON.stringify(resp.data));
            setCaseDetails(resp.data);
        }).catch(function(err) {
            console.error(err);
            if (err.response && err.response.status && err.response.status === 403) {
                (0,utils/* handleLogout */.hY)();
            }
        });
    };
    var fetchBill = function fetchBill(billId, entityQr) {
        axios_default().get("/api/backend/inventory/sales/order/fetch/" + entityQr + "/" + billId).then(function(resp) {
            setBillStatus(resp.data.status);
        }).catch(function(err) {
            console.error(err);
            if (err.response && err.response.status && err.response.status === 403) {
                (0,utils/* handleLogout */.hY)();
            }
        });
    };
    var getModalForEditCase = function getModalForEditCase() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* default */.Z, {
            show: showEditModal,
            onHide: handleCloseEditModal,
            backdrop: "static",
            className: "modal-xl",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default.Header */.Z.Header, {
                    closeButton: true
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default.Body */.Z.Body, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CaseDetailsView, {
                        cookieEntityQr: props.cookieEntityQr,
                        caseNumber: props.case && props.case.caseId,
                        doctors: props.doctors,
                        postAction: handlePostEditModal,
                        createForUhid: null
                    })
                })
            ]
        });
    };
    var getModalForBilling = function getModalForBilling() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* default */.Z, {
            show: showBillingModal,
            onHide: handleCloseBillingModal,
            backdrop: "static",
            className: "modal-xl",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default.Header */.Z.Header, {
                    closeButton: true
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default.Body */.Z.Body, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BillView/* BillView */.k, {
                        billId: props.case && props.case.salesOrderNumber,
                        customerId: null,
                        entityQr: props.cookieEntityQr,
                        postAction: handlePostBillingModal,
                        source: "IPD"
                    })
                })
            ]
        });
    };
    var getModalForDischarge = function getModalForDischarge() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* default */.Z, {
            show: showDischargeModal,
            onHide: handleCloseDischargeModal,
            backdrop: "static",
            className: "modal-xl",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default.Header */.Z.Header, {
                    closeButton: true
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default.Body */.Z.Body, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DischargeSummary/* DischargeSummary */.T, {
                        trackId: props.case.trackId,
                        isFromLink: false,
                        doctors: props.doctors
                    })
                })
            ]
        });
    };
    var getModalForCaseFile = function getModalForCaseFile() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* default */.Z, {
            show: showCaseFileModal,
            onHide: handleCloseCaseFileModal,
            backdrop: "static",
            className: "modal-xl",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default.Header */.Z.Header, {
                    closeButton: true
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default.Body */.Z.Body, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CaseFile, {
                        caseId: props.case.trackId,
                        doctors: props.doctors,
                        stateTracker: stateTracker,
                        uploads: caseDetails && caseDetails.uploads ? JSON.parse(caseDetails.uploads) : []
                    })
                })
            ]
        });
    };
    var getModalForAddRecord = function getModalForAddRecord() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* default */.Z, {
            show: showAddRecordModal,
            onHide: handleCloseAddRecordModal,
            backdrop: "static",
            className: "modal-xl",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default.Header */.Z.Header, {
                    closeButton: true
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default.Body */.Z.Body, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AddRecordView/* AddRecordView */.u, {
                        cookieEntityQr: props.cookieEntityQr,
                        uhid: props.case && props.case.uhid,
                        caseId: props.case && props.case.id,
                        caseNumber: props.case && props.case.caseId,
                        postAction: handleCloseAddRecordModal,
                        category: null,
                        assignedDr: caseDetails && caseDetails.assignedDr
                    })
                })
            ]
        });
    };
    var getModalForAddProcedure = function getModalForAddProcedure() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* default */.Z, {
            show: showAddProcedureModal,
            onHide: handleCloseAddProcedureModal,
            backdrop: "static",
            className: "modal-xl",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default.Header */.Z.Header, {
                    closeButton: true
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default.Body */.Z.Body, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AddProcedureView, {
                        cookieEntityQr: props.cookieEntityQr,
                        caseId: props.case && props.case.id,
                        postAction: handlePostAddProcedureModal,
                        doctors: props.doctors,
                        procedureData: currentProcedureData
                    })
                })
            ]
        });
    };
    var getModalForAddDischarge = function getModalForAddDischarge() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* default */.Z, {
            show: showAddDischargeModal,
            onHide: handleCloseAddDischargeModal,
            backdrop: "static",
            className: "modal-xl",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default.Header */.Z.Header, {
                    closeButton: true
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default.Body */.Z.Body, {
                    children: caseDetails && /*#__PURE__*/ (0,jsx_runtime.jsx)(AddDischargeDetailsView, {
                        cookieEntityQr: props.cookieEntityQr,
                        caseDetails: caseDetails,
                        postAction: handlePostAddDischargeModal,
                        doctors: props.doctors,
                        id: caseDetails.id
                    })
                })
            ]
        });
    };
    var getModalForAddVisitCase = function getModalForAddVisitCase() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* default */.Z, {
            show: showAddVisitModal,
            onHide: handleCloseAddVisitModal,
            backdrop: "static",
            className: "modal-xl",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default.Header */.Z.Header, {
                    closeButton: true
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default.Body */.Z.Body, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AddVisitView, {
                        cookieEntityQr: props.cookieEntityQr,
                        caseId: props.case && props.case.id,
                        postAction: handlePostAddVisitModal,
                        doctors: props.doctors,
                        visitData: currentVisitData
                    })
                })
            ]
        });
    };
    var getModalForAddBedCase = function getModalForAddBedCase() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* default */.Z, {
            show: showAddBedModal,
            onHide: handleCloseAddBedModal,
            backdrop: "static",
            className: "modal-xl",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default.Header */.Z.Header, {
                    closeButton: true
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default.Body */.Z.Body, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AddBedView, {
                        cookieEntityQr: props.cookieEntityQr,
                        caseId: props.case && props.case.id,
                        bedName: caseDetails && caseDetails.bedName,
                        postAction: handleCloseAddBedModal
                    })
                })
            ]
        });
    };
    var getModalForPrintConsentForm = function getModalForPrintConsentForm() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* default */.Z, {
            show: showPrintConsentFormModal,
            onHide: handleClosePrintConsentFormModal,
            backdrop: "static",
            className: "modal-xl",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default.Header */.Z.Header, {
                    closeButton: true
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default.Body */.Z.Body, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CaseConsentFormsView, {
                        caseDetails: caseDetails,
                        dischargeDate: null,
                        cookieEntityQr: props.cookieEntityQr
                    })
                })
            ]
        });
    };
    var getModalForFileUpload = function getModalForFileUpload() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* default */.Z, {
            show: showFileUploadModal,
            onHide: handleCloseFileUploadModal,
            backdrop: "static",
            className: "modal-xl",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default.Header */.Z.Header, {
                    closeButton: true
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default.Body */.Z.Body, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IpdUploadView, {
                        caseDetails: caseDetails,
                        fetch: fetchCase
                    })
                })
            ]
        });
    };
    var getHistory = function getHistory() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: oldCases && oldCases.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "bg-lightGrey p-3 border",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        className: "text-primary text-center",
                        children: "Patient's History"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Accordion/* default */.Z, {
                        defaultActiveKey: "0",
                        children: oldCases.map(function(c) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Accordion/* default.Item */.Z.Item, {
                                    eventKey: c.id,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Accordion/* default.Header */.Z.Header, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "fw-bold",
                                                children: [
                                                    c.caseId,
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                        className: "fw-normal",
                                                        children: [
                                                            "\xa0\xa0-\xa0\xa0(",
                                                            new Date(c.createdAt).toLocaleDateString("en-GB"),
                                                            ")"
                                                        ]
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Accordion/* default.Body */.Z.Body, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("table", {
                                                width: "100%",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                            width: "85%",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TimelineView, {
                                                                cookieEntityQr: props.cookieEntityQr,
                                                                case: c,
                                                                doctors: props.doctors,
                                                                stateTracker: null,
                                                                editProcedure: handleShowAddProcedureModal,
                                                                editVisit: showAddVisitModal,
                                                                caseStatus: c.status
                                                            }, c.id)
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                            width: "15%"
                                                        })
                                                    ]
                                                })
                                            })
                                        })
                                    ]
                                }, "doctor-schedule")
                            });
                        })
                    })
                ]
            })
        });
    };
    var ref = (0,react.useState)(false), loading = ref[0], setLoading = ref[1];
    var ref1 = (0,react.useState)([]), oldCases = ref1[0], setOldCases = ref1[1];
    var ref2 = (0,react.useState)((0,index_browser/* random */.MX)(2)), stateTracker = ref2[0], setStateTracker = ref2[1];
    var ref3 = (0,react.useState)(), billStatus = ref3[0], setBillStatus = ref3[1];
    var ref4 = (0,react.useState)(), caseDetails = ref4[0], setCaseDetails = ref4[1];
    var ref5 = (0,_sliced_to_array/* default */.Z)((0,useCookies/* default */.Z)([
        "qme"
    ]), 1), cookie = ref5[0];
    var ref6 = (0,react.useState)(false), showEditModal = ref6[0], setShowEditModal = ref6[1];
    var handlePostEditModal = function() {
        handleCloseEditModal();
    };
    var handleCloseEditModal = function() {
        return setShowEditModal(false);
    };
    var handleShowEditModal = function() {
        setShowEditModal(true);
    };
    (0,react.useEffect)(function() {
        if (props.cookieEntityQr && props.case) {
            fetchCase();
        }
    }, [
        props.cookieEntityQr,
        props.case
    ]);
    var handleCloseCase = function() {
        axios_default().post("/api/backend/ipd/case/update/status/" + props.case.id + "/CLOSED", null).then(function(resp) {
            props.clearCaseId();
            console.log(resp.data);
        }).catch(function(err) {
            console.error(err);
            if (err.response && err.response.status && err.response.status === 403) {
                (0,utils/* handleLogout */.hY)();
            }
        }).finally(function() {
            return setLoading(false);
        });
    };
    var ref7 = (0,react.useState)(false), showBillingModal = ref7[0], setShowBillingModal = ref7[1];
    var handlePostBillingModal = function() {
        fetchCase();
        handleCloseBillingModal();
    };
    var handleCloseBillingModal = function() {
        return setShowBillingModal(false);
    };
    var handleShowBillingModal = function() {
        setShowBillingModal(true);
    };
    var ref8 = (0,react.useState)(false), showDischargeModal = ref8[0], setShowDischargeModal = ref8[1];
    var handleCloseDischargeModal = function() {
        return setShowDischargeModal(false);
    };
    var handleShowDischargeModal = function() {
        setShowDischargeModal(true);
    };
    var ref9 = (0,react.useState)(false), showCaseFileModal = ref9[0], setShowCaseFileModal = ref9[1];
    var handlePostCaseFileModal = function() {
        handleCloseCaseFileModal();
    };
    var handleCloseCaseFileModal = function() {
        return setShowCaseFileModal(false);
    };
    var handleShowCaseFileModal = function() {
        setShowCaseFileModal(true);
    };
    var ref10 = (0,react.useState)(false), showAddRecordModal = ref10[0], setShowAddRecordModal = ref10[1];
    var handleCloseAddRecordModal = function() {
        setShowAddRecordModal(false);
        setStateTracker((0,index_browser/* random */.MX)(2));
    };
    var handleShowAddRecordModal = function() {
        setShowAddRecordModal(true);
    };
    var ref11 = (0,react.useState)(false), showAddProcedureModal = ref11[0], setShowAddProcedureModal = ref11[1];
    var ref12 = (0,react.useState)(null), currentProcedureData = ref12[0], setCurrentProcedureData = ref12[1];
    var handlePostAddProcedureModal = function() {
        handleCloseAddProcedureModal();
        setStateTracker((0,index_browser/* random */.MX)(2));
    };
    var handleCloseAddProcedureModal = function() {
        return setShowAddProcedureModal(false);
    };
    var handleShowAddProcedureModal = function(data) {
        setCurrentProcedureData(data);
        setShowAddProcedureModal(true);
    };
    var ref13 = (0,react.useState)(false), showAddDischargeModal = ref13[0], setShowAddDischargeModal = ref13[1];
    var ref14 = (0,react.useState)(null), dischargeData = ref14[0], setDischargeData = ref14[1];
    var handlePostAddDischargeModal = function() {
        handleCloseAddDischargeModal();
        fetchCase();
        setStateTracker((0,index_browser/* random */.MX)(2));
    };
    var handleCloseAddDischargeModal = function() {
        return setShowAddDischargeModal(false);
    };
    var handleShowAddDischargeModal = function() {
        setShowAddDischargeModal(true);
    };
    var ref15 = (0,react.useState)(false), showAddVisitModal = ref15[0], setShowAddVisitModal = ref15[1];
    var ref16 = (0,react.useState)(null), currentVisitData = ref16[0], setCurrentVisitData = ref16[1];
    var handlePostAddVisitModal = function() {
        handleCloseAddVisitModal();
        setStateTracker((0,index_browser/* random */.MX)(2));
    };
    var handleCloseAddVisitModal = function() {
        return setShowAddVisitModal(false);
    };
    var handleShowAddVisitModal = function(data) {
        setCurrentVisitData(data);
        setShowAddVisitModal(true);
    };
    var ref17 = (0,react.useState)(false), showAddBedModal = ref17[0], setShowAddBedModal = ref17[1];
    var handleCloseAddBedModal = function() {
        setShowAddBedModal(false);
        setStateTracker((0,index_browser/* random */.MX)(2));
        fetchCase();
    };
    var handleShowAddBedModal = function() {
        setShowAddBedModal(true);
    };
    var ref18 = (0,react.useState)(false), showPrintConsentFormModal = ref18[0], setShowPrintConsentFormModal = ref18[1];
    var handleClosePrintConsentFormModal = function() {
        setShowPrintConsentFormModal(false);
        setStateTracker((0,index_browser/* random */.MX)(2));
        fetchCase();
    };
    var handleShowPrintConsentFormModal = function() {
        setShowPrintConsentFormModal(true);
    };
    var ref19 = (0,react.useState)(false), showFileUploadModal = ref19[0], setShowFileUploadModal = ref19[1];
    var handleCloseFileUploadModal = function() {
        setShowFileUploadModal(false);
        setStateTracker((0,index_browser/* random */.MX)(2));
        fetchCase();
    };
    var handleShowFileUploadModal = function() {
        setShowFileUploadModal(true);
    };
    (0,react.useEffect)(function() {
        if (props.cookieEntityQr && props.case) {
            axios_default().get("/api/backend/ipd/case/fetch/all/" + props.cookieEntityQr + "?uhid=" + props.case.uhid).then(function(resp) {
                console.log(JSON.stringify(resp.data));
                setOldCases(resp.data.filter(function(c) {
                    return c.id < props.case.id;
                }));
            }).catch(function(err) {
                console.error(err);
                if (err.response && err.response.status && err.response.status === 403) {
                    (0,utils/* handleLogout */.hY)();
                }
            });
            fetchBill(props.case.salesOrderNumber, props.cookieEntityQr);
        }
    }, [
        props.cookieEntityQr,
        props.case
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "card shadow-sm min-vh-100",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "card-header",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "d-flex justify-content-between",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "d-flex",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                        className: "btn btn-primary",
                                        style: {
                                            borderRadius: "50%"
                                        },
                                        onClick: function(e) {
                                            return props.clearCaseId();
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            alt: "ipd-management",
                                            src: "/back.png",
                                            width: "14",
                                            height: "24"
                                        })
                                    }),
                                    "\xa0\xa0\xa0",
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "align-self-center text-primary font-weight-bold",
                                        children: [
                                            "Case #: ",
                                            props.case && props.case.caseId
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "d-flex",
                                children: [
                                    (0,permissions/* hasPermissions */.qX)(cookie.qme, permissions/* IPD_BILLING */.ku) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                        className: "btn btn-sm btn-outline-primary bg-white text-primary d-inline-block",
                                        onClick: handleShowBillingModal,
                                        children: "\uD83E\uDDFE Billing Information"
                                    }),
                                    "\xa0\xa0",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                        className: "btn btn-sm btn-warning text-white",
                                        onClick: handleShowDischargeModal,
                                        children: "Discharge Summary"
                                    }),
                                    "\xa0\xa0",
                                    props.case && props.case.status == "DISCHARGED" && billStatus && billStatus == "PAID" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                        className: "btn btn-sm btn-danger text-white",
                                        onClick: handleCloseCase,
                                        children: "Close Case"
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("table", {
                    width: "100%",
                    style: {
                        minHeight: "100vh"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                width: "85%",
                                className: "align-top",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Tabs/* default */.Z, {
                                    defaultActiveKey: "timeline",
                                    className: "fs-5 text-secondary nav-pills fs-6",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Tab/* default */.Z, {
                                            eventKey: "timeline",
                                            title: "\uD83D\uDD51 Timeline",
                                            children: caseDetails && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "m-3",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TimelineView, {
                                                    cookieEntityQr: props.cookieEntityQr,
                                                    case: props.case,
                                                    doctors: props.doctors,
                                                    stateTracker: stateTracker,
                                                    editProcedure: handleShowAddProcedureModal,
                                                    editVisit: handleShowAddVisitModal,
                                                    caseStatus: caseDetails.status
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Tab/* default */.Z, {
                                            eventKey: "details",
                                            title: "✎ Patient Details",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "m-3",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CaseDetailsView, {
                                                    cookieEntityQr: props.cookieEntityQr,
                                                    caseNumber: props.case && props.case.caseId,
                                                    doctors: props.doctors,
                                                    postAction: handlePostEditModal,
                                                    createForUhid: null
                                                })
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                width: "15%",
                                className: "bg-light align-top",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "text-left ml-4 mt-3",
                                    children: [
                                        props.case.status != "CLOSED" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "my-2",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        href: "#/",
                                                        className: "text-primary text-decoration-none",
                                                        onClick: handleShowAddVisitModal,
                                                        children: "Add Visit Details"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "my-2",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        href: "#/",
                                                        className: "text-primary text-decoration-none",
                                                        onClick: handleShowAddRecordModal,
                                                        children: "Add Investigations/Service Records"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "my-2",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        href: "#/",
                                                        className: "text-primary text-decoration-none",
                                                        onClick: handleShowAddProcedureModal,
                                                        children: "Add Procedure/Surgery Details"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "my-2",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        href: "#/",
                                                        className: "text-primary text-decoration-none",
                                                        onClick: handleShowAddBedModal,
                                                        children: "Assign/Unassign Bed"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "my-2",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        href: "#/",
                                                        className: "text-primary text-decoration-none",
                                                        onClick: handleShowPrintConsentFormModal,
                                                        children: "Print Consent Forms"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "my-2",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        href: "#/",
                                                        className: "text-primary text-decoration-none",
                                                        onClick: handleShowFileUploadModal,
                                                        children: "File Uploads"
                                                    })
                                                }),
                                                caseDetails && caseDetails.status == "ACTIVE" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "my-2",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        href: "#/",
                                                        className: "text-primary text-decoration-none",
                                                        onClick: handleShowAddDischargeModal,
                                                        children: "Discharge patient"
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "my-2",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                href: "#/",
                                                className: "text-primary text-decoration-none",
                                                onClick: handleShowCaseFileModal,
                                                children: "Case File"
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                }),
                getHistory(),
                getModalForEditCase(),
                getModalForBilling(),
                getModalForDischarge(),
                getModalForAddRecord(),
                getModalForAddProcedure(),
                getModalForAddDischarge(),
                getModalForAddVisitCase(),
                getModalForAddBedCase(),
                getModalForCaseFile(),
                getModalForPrintConsentForm(),
                getModalForFileUpload()
            ]
        })
    });
};

;// CONCATENATED MODULE: ./components/ipd/IPDView.tsx













var IPDView = function(props) {
    var loadEntityData = function loadEntityData() {
        axios_default().get("/api/backend/entity/profile/" + props.cookieEntityQr).then(function(resp) {
            console.log(JSON.stringify(resp.data));
            setDoctors(resp.data.clientProfileEntities);
        }).catch(function(err) {
            console.error(err);
            if (err.response && err.response.status && err.response.status === 403) {
                (0,utils/* handleLogout */.hY)();
            }
        });
    };
    var fetchCases = function fetchCases() {
        axios_default().get("/api/backend/ipd/case/fetch/all/" + props.cookieEntityQr + "?status=" + filterStatus).then(function(resp) {
            console.log(JSON.stringify(resp.data));
            setCases(resp.data);
        }).catch(function(err) {
            console.error(err);
            if (err.response && err.response.status && err.response.status === 403) {
                (0,utils/* handleLogout */.hY)();
            }
        });
    };
    var fetchCase = function fetchCase() {
        axios_default().get("/api/backend/ipd/case/fetch/" + props.cookieEntityQr + "/" + props.caseNumber).then(function(resp) {
            console.log(JSON.stringify(resp.data));
            setSelectedCase(resp.data);
            fetchCases();
        }).catch(function(err) {
            console.error(err);
            if (err.response && err.response.status && err.response.status === 403) {
                (0,utils/* handleLogout */.hY)();
            }
            fetchCases();
        });
    };
    var getModalForAddCase = function getModalForAddCase() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* default */.Z, {
            show: showAddModal,
            onHide: handleCloseAddModal,
            backdrop: "static",
            className: "modal-xl",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default.Header */.Z.Header, {
                    closeButton: true
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default.Body */.Z.Body, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CaseDetailsView, {
                        cookieEntityQr: props.cookieEntityQr,
                        caseNumber: null,
                        doctors: doctors,
                        postAction: handlePostAddModal,
                        createForUhid: props.uhid
                    })
                })
            ]
        });
    };
    var getModalForAddVisitCase = function getModalForAddVisitCase() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* default */.Z, {
            show: showAddVisitModal,
            onHide: handleCloseAddVisitModal,
            backdrop: "static",
            className: "modal-xl",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default.Header */.Z.Header, {
                    closeButton: true
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default.Body */.Z.Body, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AddVisitView, {
                        cookieEntityQr: props.cookieEntityQr,
                        caseId: selectedCaseIdForNotes,
                        postAction: handlePostAddVisitModal,
                        doctors: doctors,
                        visitData: null
                    })
                })
            ]
        });
    };
    var getModalForDeleteCase = function getModalForDeleteCase() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* default */.Z, {
            show: showDeleteCaseModal,
            onHide: handleCloseDeleteCaseModal,
            backdrop: "static",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* default.Body */.Z.Body, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "fs-5 my-3 text-danger",
                            children: "Please note that this case will not be accessible anymore. The billed items will added back to the stock. Please confirm to proceed removing the case."
                        }),
                        deleteError && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "fs-7 text-danger my-3",
                            children: deleteError
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* default.Footer */.Z.Footer, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            variant: "btn btn-secondary",
                            onClick: handleCloseDeleteCaseModal,
                            children: "Cancel"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            variant: "btn btn-primary text-white",
                            onClick: handleDeleteCase,
                            children: "Confirm"
                        })
                    ]
                })
            ]
        });
    };
    var getCasesTable = function getCasesTable() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "overflow-scroll",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* DatatableWrapper */.sm, {
                body: cases,
                headers: CASES_HEADERS,
                paginationOptionsProps: {
                    initialState: {
                        rowsPerPage: 30,
                        options: [
                            30,
                            50,
                            100
                        ]
                    }
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                        className: "mb-4 p-2",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                xs: 12,
                                lg: 4,
                                className: "d-flex flex-col justify-content-end align-items-end",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Filter */.wn, {
                                    placeholder: "Search by Case #, Name or Phone # ..."
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                xs: 12,
                                sm: 6,
                                lg: 4,
                                className: "d-flex flex-col justify-content-lg-center align-items-center justify-content-sm-start mb-2 mb-sm-0",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* PaginationOptions */.c_, {})
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                                xs: 12,
                                sm: 6,
                                lg: 4,
                                className: "d-flex flex-col justify-content-end align-items-end",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Pagination */.tl, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                        className: "btn btn-warning text-white",
                                        onClick: fetchCases,
                                        children: "↺"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Table/* default */.Z, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* TableHeader */.xD, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* TableBody */.RM, {})
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                        className: "mt-4 p-2",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                            xs: 12,
                            sm: 12,
                            lg: 12,
                            className: "d-flex flex-col justify-content-end align-items-end",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Pagination */.tl, {})
                        })
                    })
                ]
            })
        });
    };
    var getIPDDetails = function getIPDDetails() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                !loading && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        ipdEnabled && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                !selectedCase && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "row",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "col",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "card p-2 shadow-sm",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "d-flex justify-content-between py-2 pr-2",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                                className: "text-primary pl-1",
                                                                children: "IPD Cases"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "text-center",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default.Select */.Z.Select, {
                                                                    className: "form-select form-select-sm bg-light text-primary",
                                                                    value: filterStatus,
                                                                    name: "type",
                                                                    style: {
                                                                        maxWidth: 200
                                                                    },
                                                                    onChange: function(e) {
                                                                        return setFilterStatus(e.target.value);
                                                                    },
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                            value: "ACTIVE",
                                                                            children: "Active"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                            value: "DISCHARGED",
                                                                            children: "Discharged"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                            value: "CLOSED",
                                                                            children: "Closed"
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            (0,permissions/* hasPermissions */.qX)(cookie.qme, permissions/* IPD_CASE_MGT */.er) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                                className: "btn btn-warning btn-sm text-white float-right",
                                                                onClick: function(e) {
                                                                    return setShowAddModal(true);
                                                                },
                                                                children: "+ Add Case"
                                                            })
                                                        ]
                                                    }),
                                                    getCasesTable(),
                                                    getModalForAddCase(),
                                                    getModalForAddVisitCase(),
                                                    getModalForDeleteCase()
                                                ]
                                            })
                                        })
                                    })
                                }),
                                selectedCase && /*#__PURE__*/ (0,jsx_runtime.jsx)(CaseView, {
                                    cookieEntityQr: props.cookieEntityQr,
                                    case: selectedCase,
                                    doctors: doctors,
                                    clearCaseId: function() {
                                        setSelectedCase(null);
                                        fetchCases();
                                    }
                                })
                            ]
                        }),
                        !ipdEnabled && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "fs-3 text-secondary text-center py-5",
                            children: "Licence not available for this module."
                        })
                    ]
                }),
                loading && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "text-center py-5",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "spinner-border",
                        role: "status",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "sr-only",
                            children: "Loading..."
                        })
                    })
                })
            ]
        });
    };
    var ref = (0,react.useState)(true), loading = ref[0], setLoading = ref[1];
    var ref1 = (0,react.useState)([]), cases = ref1[0], setCases = ref1[1];
    var ref2 = (0,react.useState)(null), selectedCase = ref2[0], setSelectedCase = ref2[1];
    var ref3 = (0,react.useState)(false), ipdEnabled = ref3[0], setIpdEnabled = ref3[1];
    var ref4 = (0,react.useState)([]), doctors = ref4[0], setDoctors = ref4[1];
    var ref5 = (0,react.useState)("ACTIVE"), filterStatus = ref5[0], setFilterStatus = ref5[1];
    var ref6 = (0,_sliced_to_array/* default */.Z)((0,useCookies/* default */.Z)([
        "qme"
    ]), 1), cookie = ref6[0];
    (0,react.useEffect)(function() {
        if (props.cookieEntityQr) {
            loadEntityData();
            axios_default().get("/api/backend/entity/profile/" + props.cookieEntityQr).then(function(resp) {
                setIpdEnabled(resp.data.ipdEnabled);
                if (resp.data.ipdEnabled) {
                    if (props.caseNumber) {
                        fetchCase();
                    } else {
                        fetchCases();
                    }
                }
            }).catch(function(err) {
                console.error(err);
                if (err.response && err.response.status && err.response.status === 403) {
                    (0,utils/* handleLogout */.hY)();
                }
            }).finally(function() {
                setLoading(false);
            });
        }
    }, [
        props.cookieEntityQr,
        props.caseNumber
    ]);
    (0,react.useEffect)(function() {
        fetchCases();
    }, [
        filterStatus
    ]);
    (0,react.useEffect)(function() {
        if (props.uhid) {
            handleShowAddModal();
        }
    }, [
        props.uhid
    ]);
    var ref7 = (0,react.useState)(false), showAddModal = ref7[0], setShowAddModal = ref7[1];
    var handlePostAddModal = function() {
        fetchCases();
        handleCloseAddModal();
    };
    var handleCloseAddModal = function() {
        return setShowAddModal(false);
    };
    var handleShowAddModal = function() {
        setShowAddModal(true);
    };
    var ref8 = (0,react.useState)(false), showAddVisitModal = ref8[0], setShowAddVisitModal = ref8[1];
    var ref9 = (0,react.useState)(), selectedCaseIdForNotes = ref9[0], setSelectedCaseIdForNotes = ref9[1];
    var handlePostAddVisitModal = function() {
        handleCloseAddVisitModal();
    };
    var handleCloseAddVisitModal = function() {
        return setShowAddVisitModal(false);
    };
    var handleShowAddVisitModal = function(selectedCaseIdForNotes) {
        setSelectedCaseIdForNotes(selectedCaseIdForNotes);
        setShowAddVisitModal(true);
    };
    var ref10 = (0,react.useState)(false), showDeleteCaseModal = ref10[0], setShowDeleteCaseModal = ref10[1];
    var ref11 = (0,react.useState)(), selectedCaseIdForDelete = ref11[0], setSelectedCaseIdForDelete = ref11[1];
    var ref12 = (0,react.useState)(null), deleteError = ref12[0], setDeleteError = ref12[1];
    var handleCloseDeleteCaseModal = function() {
        return setShowDeleteCaseModal(false);
    };
    var handleShowDeleteCaseModal = function(selectedCaseIdForDelete) {
        setDeleteError(null);
        setSelectedCaseIdForDelete(selectedCaseIdForDelete);
        setShowDeleteCaseModal(true);
    };
    var handleDeleteCase = function() {
        axios_default()["delete"]("/api/backend/ipd/case/delete/" + selectedCaseIdForDelete).then(function(resp) {
            console.log(JSON.stringify(resp.data));
            setShowDeleteCaseModal(false);
            fetchCases();
        }).catch(function(err) {
            console.error(err);
            if (err.response && err.response.status && err.response.status === 403) {
                (0,utils/* handleLogout */.hY)();
            }
            setDeleteError("* Something went wrong! try again later.");
        });
    };
    var CASES_HEADERS = [
        {
            prop: "sno",
            title: "#",
            isFilterable: false,
            isSortable: true
        },
        {
            prop: "caseId",
            title: "Case #",
            isFilterable: true,
            isSortable: true,
            cell: function(row) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                        href: "#/",
                        className: "text-decoration-none text-primary",
                        onClick: function(e) {
                            return setSelectedCase(row);
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                height: "14rem",
                                width: "14rem",
                                src: "/external-link.png",
                                alt: "external-link-icon",
                                className: "align-self-center"
                            }),
                            "\xa0\xa0",
                            row.caseId
                        ]
                    })
                });
            }
        },
        {
            prop: "ipdId",
            title: "IPD #.",
            isFilterable: true,
            isSortable: true,
            cell: function(row) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: (0,utils/* padNumber */.vX)(row.ipdId)
                });
            }
        },
        {
            prop: "extUhid",
            title: "Hospital UHID",
            isFilterable: true
        },
        {
            prop: "uhid",
            title: "UHID",
            isFilterable: true
        },
        {
            prop: "customerName",
            title: "Patient Name",
            isFilterable: true
        },
        {
            prop: "assignedDr",
            title: "Doctor In-charge",
            isFilterable: true
        },
        {
            prop: "bedName",
            title: "Bed",
            isSortable: true,
            isFilterable: true
        },
        {
            prop: "customerMobile",
            title: "Phone no",
            isFilterable: true
        },
        {
            prop: "status",
            title: "Status",
            isFilterable: true,
            isSortable: true,
            cell: function(row) {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        row.status == "ACTIVE" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "text-success",
                            children: "Active"
                        }),
                        row.status == "SUMMARY_APPROVED" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "text-danger",
                            children: "Discharge Approved"
                        }),
                        row.status == "DISCHARGED" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "text-danger",
                            children: "Discharged"
                        }),
                        row.status == "BILL_PAID" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "text-danger",
                            children: "Bill Paid"
                        }),
                        row.status == "CLOSED" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "text-danger",
                            children: "Closed"
                        })
                    ]
                });
            }
        },
        {
            prop: "actions",
            title: "Actions",
            cell: function(row) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: row.status == "ACTIVE" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "#/",
                                className: "fs-5",
                                onClick: function(e) {
                                    return handleShowAddVisitModal(row.id);
                                },
                                children: "\uD83D\uDCDD"
                            }),
                            "\xa0\xa0\xa0",
                            (0,permissions/* hasPermissions */.qX)(cookie.qme, permissions/* IPD_CASE_MGT */.er) && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "#/",
                                className: "remove",
                                onClick: function(e) {
                                    return handleShowDeleteCaseModal(row.id);
                                },
                                children: "X"
                            })
                        ]
                    })
                });
            }
        }, 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "row mx-lg-5",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "col",
                children: getIPDDetails()
            })
        })
    });
};


/***/ }),

/***/ 54242:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ AddRecordView; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(70655);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var components_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(90759);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_vertical_timeline_component_style_min_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(74107);
/* harmony import */ var react_vertical_timeline_component_style_min_css__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(react_vertical_timeline_component_style_min_css__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _diagnostics_DiagnosticsVisitView__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(71992);








var AddRecordView = function(props) {
    var fetchServices = function fetchServices() {
        axios__WEBPACK_IMPORTED_MODULE_3___default().get("/api/backend/inventory/item/fetch/all/" + props.cookieEntityQr + "?type=SERVICE").then(function(resp) {
            console.log(JSON.stringify(resp.data));
            setServices(resp.data);
        }).catch(function(err) {
            console.error(err);
            if (err.response && err.response.status && err.response.status === 403) {
                (0,components_utils__WEBPACK_IMPORTED_MODULE_1__/* .handleLogout */ .hY)();
            }
        });
    };
    var getAddNewWidget = function getAddNewWidget() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_diagnostics_DiagnosticsVisitView__WEBPACK_IMPORTED_MODULE_5__/* .DiagnosticsVisitView */ .e, {
                    uhid: props.uhid,
                    visitId: visitId,
                    entityQr: props.cookieEntityQr,
                    source: "IPD",
                    diagnosticCategory: props.category,
                    shouldAddNew: true,
                    createVisit: createAuditItem
                }),
                errorMessage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "text-danger fs-6",
                    children: [
                        "*",
                        errorMessage
                    ]
                })
            ]
        });
    };
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(null), successMessage = ref[0], setSuccessMessage = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), loading = ref1[0], setLoading = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(null), errorMessage = ref2[0], setErrorMessage = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(), services = ref3[0], setServices = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(null), visitId = ref4[0], setVisitId = ref4[1];
    var componentRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (props.cookieEntityQr) {
            fetchServices();
        }
    }, [
        props.cookieEntityQr
    ]);
    var handleSubmit = function(e) {
        if (e) {
            e.preventDefault();
        }
        componentRef.current.handleAddRecord(props.uhid, props.caseId);
        setSuccessMessage("");
        setErrorMessage("");
    };
    function createAuditItem() {
        return _createAuditItem.apply(this, arguments);
    }
    function _createAuditItem() {
        _createAuditItem = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function() {
            var resp, _tmp;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _tmp = {};
                        return [
                            4,
                            axios__WEBPACK_IMPORTED_MODULE_3___default().post("/api/backend/ipd/case/audit/create/", (_tmp.entityQr = props.cookieEntityQr, _tmp.caseId = props.caseId, _tmp.medicalRecordId = null, _tmp.itemId = null, _tmp.type = "SERVICE", _tmp))
                        ];
                    case 1:
                        resp = _state.sent();
                        console.log(resp.data);
                        setVisitId(resp.data);
                        return [
                            2,
                            resp.data
                        ];
                }
            });
        });
        return _createAuditItem.apply(this, arguments);
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: getAddNewWidget()
    });
};


/***/ })

}]);